


// // // // // import React, { useState, useEffect, useCallback } from 'react';
// // // // // import {
// // // // //   Dialog,
// // // // //   DialogTitle,
// // // // //   DialogContent,
// // // // //   DialogActions,
// // // // //   Button,
// // // // //   Box,
// // // // //   Typography,
// // // // //   TextField,
// // // // //   Chip,
// // // // //   Avatar,
// // // // //   IconButton,
// // // // //   CircularProgress,
// // // // //   Divider,
// // // // //   Alert,
// // // // // } from '@mui/material';
// // // // // import {
// // // // //   Search as SearchIcon,
// // // // //   Close as CloseIcon,
// // // // //   PersonAdd as PersonAddIcon,
// // // // //   PersonRemove as PersonRemoveIcon,
// // // // //   CheckCircle as CheckCircleIcon,
// // // // // } from '@mui/icons-material';
// // // // // import api from '../../../api/axiosInterceptor';


// // // // // export const BulkPermissionDialog = ({ open, onClose, rows, onSuccess, onError }) => {
// // // // //   const [mode, setMode] = useState('add'); // 'add' | 'remove'
// // // // //   const [startRefId, setStartRefId] = useState('');
// // // // //   const [endRefId, setEndRefId] = useState('');
// // // // //   const [rangePreview, setRangePreview] = useState([]);
// // // // //   const [allUsers, setAllUsers] = useState([]);
// // // // //   const [searchEmail, setSearchEmail] = useState('');
// // // // //   const [filteredUsers, setFilteredUsers] = useState([]);
// // // // //   const [pickedUsers, setPickedUsers] = useState([]);
// // // // //   const [loadingUsers, setLoadingUsers] = useState(false);
// // // // //   const [shrName, setShrName] = useState('');
// // // // //   const [shrSearch, setShrSearch] = useState('');
// // // // //   const [shrFilteredUsers, setShrFilteredUsers] = useState([]);
// // // // //   const [pickedShr, setPickedShr] = useState(null);
// // // // //   const [submitting, setSubmitting] = useState(false);


// // // // //   // Fetch users on open
// // // // //   useEffect(() => {
// // // // //     if (!open) return;
// // // // //     setLoadingUsers(true);
// // // // //     api.get('/auth/role-mgmt/')
// // // // //       .then(res => {
// // // // //         const usersArray = Array.isArray(res.data) ? res.data : res.data?.users || [];
// // // // //         setAllUsers(usersArray);
// // // // //       })
// // // // //       .catch(() => onError('Failed to load users.'))
// // // // //       .finally(() => setLoadingUsers(false));
// // // // //   }, [open, onError]);


// // // // //   // Range preview
// // // // //   useEffect(() => {
// // // // //     if (!startRefId || !endRefId || !Array.isArray(rows) || rows.length === 0) {
// // // // //       setRangePreview([]);
// // // // //       return;
// // // // //     }
// // // // //     const sorted = [...rows].sort((a, b) => a.reference_id.localeCompare(b.reference_id));
// // // // //     setRangePreview(sorted.filter(r => r.reference_id >= startRefId && r.reference_id <= endRefId));
// // // // //   }, [startRefId, endRefId, rows]);


// // // // //   // Filter users for regular search
// // // // //   useEffect(() => {
// // // // //     if (!searchEmail.trim()) {
// // // // //       setFilteredUsers([]);
// // // // //       return;
// // // // //     }
// // // // //     const q = searchEmail.toLowerCase();
// // // // //     setFilteredUsers(
// // // // //       (Array.isArray(allUsers) ? allUsers : []).filter(
// // // // //         u => u.email?.toLowerCase().includes(q) || u.name?.toLowerCase().includes(q)
// // // // //       ).slice(0, 8)
// // // // //     );
// // // // //   }, [searchEmail, allUsers]);


// // // // //   // Filter users for SHR search
// // // // //   useEffect(() => {
// // // // //     if (!shrSearch.trim()) {
// // // // //       setShrFilteredUsers([]);
// // // // //       return;
// // // // //     }
// // // // //     const q = shrSearch.toLowerCase();
// // // // //     setShrFilteredUsers(
// // // // //       (Array.isArray(allUsers) ? allUsers : []).filter(
// // // // //         u => u.email?.toLowerCase().includes(q) || u.name?.toLowerCase().includes(q)
// // // // //       ).slice(0, 8)
// // // // //     );
// // // // //   }, [shrSearch, allUsers]);


// // // // //   const handleClose = useCallback(() => {
// // // // //     setStartRefId('');
// // // // //     setEndRefId('');
// // // // //     setRangePreview([]);
// // // // //     setSearchEmail('');
// // // // //     setFilteredUsers([]);
// // // // //     setPickedUsers([]);
// // // // //     setShrName('');
// // // // //     setShrSearch('');
// // // // //     setShrFilteredUsers([]);
// // // // //     setPickedShr(null);
// // // // //     setMode('add');
// // // // //     onClose();
// // // // //   }, [onClose]);


// // // // //   const toggleUser = (user) => {
// // // // //     setPickedUsers(prev =>
// // // // //       prev.some(u => u.id === user.id)
// // // // //         ? prev.filter(u => u.id !== user.id)
// // // // //         : [...prev, user]
// // // // //     );
// // // // //   };


// // // // //   const toggleShr = (user) => {
// // // // //     if (pickedShr?.id === user.id) {
// // // // //       setPickedShr(null);
// // // // //       setShrName('');
// // // // //     } else {
// // // // //       setPickedShr(user);
// // // // //       setShrName(user.name || '');
// // // // //     }
// // // // //   };


// // // // //   const handleSubmit = async () => {
// // // // //     if (!Array.isArray(rangePreview) || rangePreview.length === 0) {
// // // // //       onError('No records match the entered range.');
// // // // //       return;
// // // // //     }
// // // // //     if (!Array.isArray(pickedUsers) || pickedUsers.length === 0) {
// // // // //       onError('Please select at least one user.');
// // // // //       return;
// // // // //     }


// // // // //     const payload = {
// // // // //       excess_ids: rangePreview.map(r => r.id),
// // // // //       user_ids: pickedUsers.map(u => u.id),
// // // // //       ...(mode === 'add' && shrName.trim() ? { shr_name: shrName.trim() } : {}),
// // // // //     };


// // // // //     try {
// // // // //       setSubmitting(true);
// // // // //       if (mode === 'add') {
// // // // //         const res = await api.post('/excess_payment_mgmt/excess/bulk-permission/', payload);
// // // // //         onSuccess(`Permissions added. Created: ${res.data.created_count}, Skipped: ${res.data.skipped_count}.`);
// // // // //       } else {
// // // // //         const res = await api.delete('/excess_payment_mgmt/excess/bulk-permission/', { data: payload });
// // // // //         onSuccess(`Permissions removed. Deleted: ${res.data.deleted_count}.`);
// // // // //       }
// // // // //       handleClose();
// // // // //     } catch (err) {
// // // // //       onError(err?.response?.data?.error || 'Failed to update permissions.');
// // // // //     } finally {
// // // // //       setSubmitting(false);
// // // // //     }
// // // // //   };


// // // // //   const isAdd = mode === 'add';


// // // // //   return (
// // // // //     <Dialog open={open} onClose={!submitting ? handleClose : undefined} maxWidth="sm" fullWidth>
// // // // //       <DialogTitle sx={{ pb: 1 }}>
// // // // //         <Box display="flex" justifyContent="space-between" alignItems="center">
// // // // //           <Typography variant="h6" fontWeight="bold">Bulk Permission Management</Typography>
// // // // //           <IconButton size="small" onClick={handleClose} disabled={submitting}>
// // // // //             <CloseIcon fontSize="small" />
// // // // //           </IconButton>
// // // // //         </Box>
// // // // //       </DialogTitle>
// // // // //       <Divider />
// // // // //       <DialogContent sx={{ pt: 2 }}>
// // // // //         <Box display="flex" flexDirection="column" gap={2.5}>
// // // // //           {/* Mode Toggle */}
// // // // //           <Box display="flex" gap={1}>
// // // // //             <Button
// // // // //               variant={isAdd ? 'contained' : 'outlined'} color="primary"
// // // // //               startIcon={<PersonAddIcon />} onClick={() => setMode('add')}
// // // // //               disabled={submitting} size="small" sx={{ flex: 1 }}
// // // // //             >Add Permission</Button>
// // // // //             <Button
// // // // //               variant={!isAdd ? 'contained' : 'outlined'} color="error"
// // // // //               startIcon={<PersonRemoveIcon />} onClick={() => setMode('remove')}
// // // // //               disabled={submitting} size="small" sx={{ flex: 1 }}
// // // // //             >Remove Permission</Button>
// // // // //           </Box>


// // // // //           {/* Reference ID Range */}
// // // // //           <Box>
// // // // //             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// // // // //               Reference ID Range
// // // // //             </Typography>
// // // // //             <Box display="flex" gap={2}>
// // // // //               <TextField
// // // // //                 fullWidth size="small" label="From Reference ID"
// // // // //                 value={startRefId} onChange={e => setStartRefId(e.target.value)}
// // // // //                 disabled={submitting}
// // // // //               />
// // // // //               <TextField
// // // // //                 fullWidth size="small" label="To Reference ID"
// // // // //                 value={endRefId} onChange={e => setEndRefId(e.target.value)}
// // // // //                 disabled={submitting}
// // // // //               />
// // // // //             </Box>


// // // // //             {startRefId && endRefId && (
// // // // //               <Box mt={1}>
// // // // //                 {(Array.isArray(rangePreview) && rangePreview.length > 0) ? (
// // // // //                   <Alert severity={isAdd ? 'info' : 'warning'} sx={{ py: 0.5 }}>
// // // // //                     <strong>{rangePreview.length} record(s)</strong> matched —{' '}
// // // // //                     {rangePreview.slice(0, 3).map(r => r.reference_id).join(', ')}
// // // // //                     {rangePreview.length > 3 && ` ... +${rangePreview.length - 3} more`}
// // // // //                   </Alert>
// // // // //                 ) : (
// // // // //                   <Alert severity="error" sx={{ py: 0.5 }}>No records match this range.</Alert>
// // // // //                 )}
// // // // //               </Box>
// // // // //             )}
// // // // //           </Box>


// // // // //           {/* SHR Name Search */}
// // // // //           {isAdd && (
// // // // //             <Box>
// // // // //               <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// // // // //                 Authorized SHR Name (optional)
// // // // //               </Typography>
// // // // //               <TextField
// // // // //                 fullWidth size="small"
// // // // //                 placeholder="Type email or name to search..."
// // // // //                 value={shrSearch}
// // // // //                 onChange={e => setShrSearch(e.target.value)}
// // // // //                 disabled={submitting || loadingUsers}
// // // // //                 InputProps={{
// // // // //                   startAdornment: loadingUsers ? <CircularProgress size={16} sx={{ mr: 1 }} /> : <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.disabled' }} />,
// // // // //                   endAdornment: shrSearch && (
// // // // //                     <IconButton size="small" onClick={() => { setShrSearch(''); setPickedShr(null); setShrName(''); }}>
// // // // //                       <CloseIcon fontSize="small" />
// // // // //                     </IconButton>
// // // // //                   ),
// // // // //                 }}
// // // // //               />


// // // // //               {(Array.isArray(shrFilteredUsers) && shrFilteredUsers.length > 0) && (
// // // // //                 <Box sx={{ mt: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, maxHeight: 180, overflow: 'auto' }}>
// // // // //                   {shrFilteredUsers.map((user, idx) => {
// // // // //                     const isPicked = pickedShr?.id === user.id;
// // // // //                     return (
// // // // //                       <Box
// // // // //                         key={user.id}
// // // // //                         onClick={() => toggleShr(user)}
// // // // //                         sx={{
// // // // //                           display: 'flex', alignItems: 'center', gap: 1.5,
// // // // //                           px: 2, py: 1, cursor: 'pointer',
// // // // //                           bgcolor: isPicked ? 'primary.50' : 'transparent',
// // // // //                           borderBottom: idx < shrFilteredUsers.length - 1 ? '1px solid' : 'none',
// // // // //                           borderColor: 'divider',
// // // // //                           '&:hover': { bgcolor: isPicked ? 'primary.100' : 'action.hover' },
// // // // //                           transition: 'background 0.15s',
// // // // //                         }}
// // // // //                       >
// // // // //                         <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: isPicked ? 'primary.main' : 'grey.400' }}>
// // // // //                           {user.name?.[0]?.toUpperCase() || '?'}
// // // // //                         </Avatar>
// // // // //                         <Box flex={1} minWidth={0}>
// // // // //                           <Typography variant="body2" fontWeight={isPicked ? 600 : 400} noWrap>{user.name}</Typography>
// // // // //                           <Typography variant="caption" color="text.secondary" noWrap>{user.email}</Typography>
// // // // //                         </Box>
// // // // //                         {isPicked && <CheckCircleIcon fontSize="small" color="primary" />}
// // // // //                       </Box>
// // // // //                     );
// // // // //                   })}
// // // // //                 </Box>
// // // // //               )}


// // // // //               {pickedShr && (
// // // // //                 <Box mt={1}>
// // // // //                   <Chip
// // // // //                     label={pickedShr.name}
// // // // //                     size="small"
// // // // //                     avatar={
// // // // //                       <Avatar sx={{ bgcolor: 'primary.main', fontSize: 11 }}>
// // // // //                         {pickedShr.name?.[0]?.toUpperCase()}
// // // // //                       </Avatar>
// // // // //                     }
// // // // //                     onDelete={() => { setPickedShr(null); setShrSearch(''); setShrName(''); }}
// // // // //                     color="primary"
// // // // //                     variant="outlined"
// // // // //                   />
// // // // //                 </Box>
// // // // //               )}
// // // // //             </Box>
// // // // //           )}


// // // // //           {/* User Search */}
// // // // //           <Box>
// // // // //             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// // // // //               Search &amp; Select Users by Email
// // // // //             </Typography>
// // // // //             <TextField
// // // // //               fullWidth size="small"
// // // // //               placeholder="Type email or name to search..."
// // // // //               value={searchEmail}
// // // // //               onChange={e => setSearchEmail(e.target.value)}
// // // // //               disabled={submitting || loadingUsers}
// // // // //               InputProps={{
// // // // //                 startAdornment: loadingUsers ? <CircularProgress size={16} sx={{ mr: 1 }} /> : <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.disabled' }} />,
// // // // //                 endAdornment: searchEmail && (
// // // // //                   <IconButton size="small" onClick={() => setSearchEmail('')}>
// // // // //                     <CloseIcon fontSize="small" />
// // // // //                   </IconButton>
// // // // //                 ),
// // // // //               }}
// // // // //             />


// // // // //             {(Array.isArray(filteredUsers) && filteredUsers.length > 0) && (
// // // // //               <Box sx={{ mt: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, maxHeight: 180, overflow: 'auto' }}>
// // // // //                 {filteredUsers.map((user, idx) => {
// // // // //                   const isPicked = pickedUsers.some(u => u.id === user.id);
// // // // //                   return (
// // // // //                     <Box
// // // // //                       key={user.id}
// // // // //                       onClick={() => toggleUser(user)}
// // // // //                       sx={{
// // // // //                         display: 'flex', alignItems: 'center', gap: 1.5,
// // // // //                         px: 2, py: 1, cursor: 'pointer',
// // // // //                         bgcolor: isPicked ? 'primary.50' : 'transparent',
// // // // //                         borderBottom: idx < filteredUsers.length - 1 ? '1px solid' : 'none',
// // // // //                         borderColor: 'divider',
// // // // //                         '&:hover': { bgcolor: isPicked ? 'primary.100' : 'action.hover' },
// // // // //                         transition: 'background 0.15s',
// // // // //                       }}
// // // // //                     >
// // // // //                       <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: isPicked ? 'primary.main' : 'grey.400' }}>
// // // // //                         {user.name?.[0]?.toUpperCase() || '?'}
// // // // //                       </Avatar>
// // // // //                       <Box flex={1} minWidth={0}>
// // // // //                         <Typography variant="body2" fontWeight={isPicked ? 600 : 400} noWrap>{user.name}</Typography>
// // // // //                         <Typography variant="caption" color="text.secondary" noWrap>{user.email}</Typography>
// // // // //                       </Box>
// // // // //                       {isPicked && <CheckCircleIcon fontSize="small" color="primary" />}
// // // // //                     </Box>
// // // // //                   );
// // // // //                 })}
// // // // //               </Box>
// // // // //             )}
// // // // //           </Box>


// // // // //           {/* Picked Users Chips */}
// // // // //           {(Array.isArray(pickedUsers) && pickedUsers.length > 0) && (
// // // // //             <Box>
// // // // //               <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// // // // //                 Selected Users ({pickedUsers.length})
// // // // //               </Typography>
// // // // //               <Box display="flex" flexWrap="wrap" gap={0.75}>
// // // // //                 {pickedUsers.map(user => (
// // // // //                   <Chip
// // // // //                     key={user.id}
// // // // //                     label={user.email}
// // // // //                     size="small"
// // // // //                     avatar={
// // // // //                       <Avatar sx={{ bgcolor: isAdd ? 'primary.main' : 'error.main', fontSize: 11 }}>
// // // // //                         {user.name?.[0]?.toUpperCase()}
// // // // //                       </Avatar>
// // // // //                     }
// // // // //                     onDelete={() => setPickedUsers(prev => prev.filter(u => u.id !== user.id))}
// // // // //                     color={isAdd ? 'primary' : 'error'}
// // // // //                     variant="outlined"
// // // // //                   />
// // // // //                 ))}
// // // // //               </Box>
// // // // //             </Box>
// // // // //           )}


// // // // //           {/* Summary */}
// // // // //           {(Array.isArray(rangePreview) && rangePreview.length > 0 && Array.isArray(pickedUsers) && pickedUsers.length > 0) && (
// // // // //             <Alert severity={isAdd ? 'success' : 'warning'} sx={{ py: 0.5 }}>
// // // // //               {isAdd
// // // // //                 ? `Will grant ${pickedUsers.length} user(s) access to ${rangePreview.length} record(s).`
// // // // //                 : `Will revoke ${pickedUsers.length} user(s) access from ${rangePreview.length} record(s).`}
// // // // //             </Alert>
// // // // //           )}
// // // // //         </Box>
// // // // //       </DialogContent>


// // // // //       <Divider />


// // // // //       <DialogActions sx={{ px: 3, py: 2 }}>
// // // // //         <Button onClick={handleClose} disabled={submitting}>Cancel</Button>
// // // // //         <Button
// // // // //           onClick={handleSubmit}
// // // // //           variant="contained"
// // // // //           color={isAdd ? 'primary' : 'error'}
// // // // //           disabled={submitting || !Array.isArray(rangePreview) || rangePreview.length === 0 || !Array.isArray(pickedUsers) || pickedUsers.length === 0}
// // // // //           startIcon={submitting
// // // // //             ? <CircularProgress size={16} color="inherit" />
// // // // //             : isAdd ? <PersonAddIcon /> : <PersonRemoveIcon />}
// // // // //         >
// // // // //           {submitting
// // // // //             ? 'Processing...'
// // // // //             : isAdd
// // // // //               ? `Grant to ${rangePreview.length} Record(s)`
// // // // //               : `Revoke from ${rangePreview.length} Record(s)`}
// // // // //         </Button>
// // // // //       </DialogActions>
// // // // //     </Dialog>
// // // // //   );
// // // // // };


// // // // import React, { useState, useEffect, useCallback } from 'react';
// // // // import {
// // // //   Dialog,
// // // //   DialogTitle,
// // // //   DialogContent,
// // // //   DialogActions,
// // // //   Button,
// // // //   Box,
// // // //   Typography,
// // // //   TextField,
// // // //   Chip,
// // // //   Avatar,
// // // //   IconButton,
// // // //   CircularProgress,
// // // //   Divider,
// // // //   Alert,
// // // // } from '@mui/material';
// // // // import {
// // // //   Search as SearchIcon,
// // // //   Close as CloseIcon,
// // // //   PersonAdd as PersonAddIcon,
// // // //   PersonRemove as PersonRemoveIcon,
// // // //   CheckCircle as CheckCircleIcon,
// // // // } from '@mui/icons-material';
// // // // import api from '../../../api/axiosInterceptor';


// // // // export const BulkPermissionDialog = ({ open, onClose, rows, onSuccess, onError }) => {
// // // //   const [mode, setMode] = useState('add'); // 'add' | 'remove'
// // // //   const [startRefId, setStartRefId] = useState('');
// // // //   const [endRefId, setEndRefId] = useState('');
// // // //   const [rangePreview, setRangePreview] = useState([]);
// // // //   const [allUsers, setAllUsers] = useState([]);
// // // //   const [searchEmail, setSearchEmail] = useState('');
// // // //   const [filteredUsers, setFilteredUsers] = useState([]);
// // // //   const [pickedUsers, setPickedUsers] = useState([]);
// // // //   const [loadingUsers, setLoadingUsers] = useState(false);
// // // //   const [shrName, setShrName] = useState('');
// // // //   const [shrSearch, setShrSearch] = useState('');
// // // //   const [shrFilteredUsers, setShrFilteredUsers] = useState([]);
// // // //   const [pickedShr, setPickedShr] = useState(null);

// // // //   // Forensic Auditor — multi-select, same UX as Users field
// // // //   const [forensicSearch, setForensicSearch] = useState('');
// // // //   const [filteredForensicUsers, setFilteredForensicUsers] = useState([]);
// // // //   const [pickedForensic, setPickedForensic] = useState([]);

// // // //   const [submitting, setSubmitting] = useState(false);


// // // //   // Fetch users on open
// // // //   useEffect(() => {
// // // //     if (!open) return;
// // // //     setLoadingUsers(true);
// // // //     api.get('/auth/role-mgmt/')
// // // //       .then(res => {
// // // //         const usersArray = Array.isArray(res.data) ? res.data : res.data?.users || [];
// // // //         setAllUsers(usersArray);
// // // //       })
// // // //       .catch(() => onError('Failed to load users.'))
// // // //       .finally(() => setLoadingUsers(false));
// // // //   }, [open, onError]);


// // // //   // Range preview
// // // //   useEffect(() => {
// // // //     if (!startRefId || !endRefId || !Array.isArray(rows) || rows.length === 0) {
// // // //       setRangePreview([]);
// // // //       return;
// // // //     }
// // // //     const sorted = [...rows].sort((a, b) => a.reference_id.localeCompare(b.reference_id));
// // // //     setRangePreview(sorted.filter(r => r.reference_id >= startRefId && r.reference_id <= endRefId));
// // // //   }, [startRefId, endRefId, rows]);


// // // //   // Filter users for regular search
// // // //   useEffect(() => {
// // // //     if (!searchEmail.trim()) {
// // // //       setFilteredUsers([]);
// // // //       return;
// // // //     }
// // // //     const q = searchEmail.toLowerCase();
// // // //     setFilteredUsers(
// // // //       (Array.isArray(allUsers) ? allUsers : []).filter(
// // // //         u => u.email?.toLowerCase().includes(q) || u.name?.toLowerCase().includes(q)
// // // //       ).slice(0, 8)
// // // //     );
// // // //   }, [searchEmail, allUsers]);


// // // //   // Filter users for SHR search
// // // //   useEffect(() => {
// // // //     if (!shrSearch.trim()) {
// // // //       setShrFilteredUsers([]);
// // // //       return;
// // // //     }
// // // //     const q = shrSearch.toLowerCase();
// // // //     setShrFilteredUsers(
// // // //       (Array.isArray(allUsers) ? allUsers : []).filter(
// // // //         u => u.email?.toLowerCase().includes(q) || u.name?.toLowerCase().includes(q)
// // // //       ).slice(0, 8)
// // // //     );
// // // //   }, [shrSearch, allUsers]);


// // // //   // Filter users for Forensic Auditor search
// // // //   useEffect(() => {
// // // //     if (!forensicSearch.trim()) {
// // // //       setFilteredForensicUsers([]);
// // // //       return;
// // // //     }
// // // //     const q = forensicSearch.toLowerCase();
// // // //     setFilteredForensicUsers(
// // // //       (Array.isArray(allUsers) ? allUsers : []).filter(
// // // //         u => u.email?.toLowerCase().includes(q) || u.name?.toLowerCase().includes(q)
// // // //       ).slice(0, 8)
// // // //     );
// // // //   }, [forensicSearch, allUsers]);


// // // //   const handleClose = useCallback(() => {
// // // //     setStartRefId('');
// // // //     setEndRefId('');
// // // //     setRangePreview([]);
// // // //     setSearchEmail('');
// // // //     setFilteredUsers([]);
// // // //     setPickedUsers([]);
// // // //     setShrName('');
// // // //     setShrSearch('');
// // // //     setShrFilteredUsers([]);
// // // //     setPickedShr(null);
// // // //     setForensicSearch('');
// // // //     setFilteredForensicUsers([]);
// // // //     setPickedForensic([]);
// // // //     setMode('add');
// // // //     onClose();
// // // //   }, [onClose]);


// // // //   const toggleUser = (user) => {
// // // //     setPickedUsers(prev =>
// // // //       prev.some(u => u.id === user.id)
// // // //         ? prev.filter(u => u.id !== user.id)
// // // //         : [...prev, user]
// // // //     );
// // // //   };


// // // //   const toggleShr = (user) => {
// // // //     if (pickedShr?.id === user.id) {
// // // //       setPickedShr(null);
// // // //       setShrName('');
// // // //     } else {
// // // //       setPickedShr(user);
// // // //       setShrName(user.name || '');
// // // //     }
// // // //   };


// // // //   const toggleForensic = (user) => {
// // // //     setPickedForensic(prev =>
// // // //       prev.some(u => u.id === user.id)
// // // //         ? prev.filter(u => u.id !== user.id)
// // // //         : [...prev, user]
// // // //     );
// // // //   };


// // // //   const handleSubmit = async () => {
// // // //     if (!Array.isArray(rangePreview) || rangePreview.length === 0) {
// // // //       onError('No records match the entered range.');
// // // //       return;
// // // //     }
// // // //     if (!Array.isArray(pickedUsers) || pickedUsers.length === 0) {
// // // //       onError('Please select at least one user.');
// // // //       return;
// // // //     }
// // // //     if (mode === 'add' && !shrName.trim()) {
// // // //       onError('SHR Name is required.');
// // // //       return;
// // // //     }
// // // //     if (mode === 'add' && (!Array.isArray(pickedForensic) || pickedForensic.length === 0)) {
// // // //       onError('Please select at least one Forensic Auditor.');
// // // //       return;
// // // //     }

// // // //     const payload = {
// // // //       excess_ids: rangePreview.map(r => r.id),
// // // //       user_ids: pickedUsers.map(u => u.id),
// // // //       ...(mode === 'add'
// // // //         ? {
// // // //             shr_name: shrName.trim(),
// // // //             forensic_auditor_ids: pickedForensic.map(u => u.id),
// // // //           }
// // // //         : {}),
// // // //     };

// // // //     try {
// // // //       setSubmitting(true);
// // // //       if (mode === 'add') {
// // // //         const res = await api.post('/excess_payment_mgmt/excess/bulk-permission/', payload);
// // // //         onSuccess(`Permissions added. Created: ${res.data.created_count}, Skipped: ${res.data.skipped_count}.`);
// // // //       } else {
// // // //         const res = await api.delete('/excess_payment_mgmt/excess/bulk-permission/', { data: payload });
// // // //         onSuccess(`Permissions removed. Deleted: ${res.data.deleted_count}.`);
// // // //       }
// // // //       handleClose();
// // // //     } catch (err) {
// // // //       onError(err?.response?.data?.error || 'Failed to update permissions.');
// // // //     } finally {
// // // //       setSubmitting(false);
// // // //     }
// // // //   };


// // // //   const isAdd = mode === 'add';


// // // //   return (
// // // //     <Dialog open={open} onClose={!submitting ? handleClose : undefined} maxWidth="sm" fullWidth>
// // // //       <DialogTitle sx={{ pb: 1 }}>
// // // //         <Box display="flex" justifyContent="space-between" alignItems="center">
// // // //           <Typography variant="h6" fontWeight="bold">Bulk Permission Management</Typography>
// // // //           <IconButton size="small" onClick={handleClose} disabled={submitting}>
// // // //             <CloseIcon fontSize="small" />
// // // //           </IconButton>
// // // //         </Box>
// // // //       </DialogTitle>
// // // //       <Divider />
// // // //       <DialogContent sx={{ pt: 2 }}>
// // // //         <Box display="flex" flexDirection="column" gap={2.5}>
// // // //           {/* Mode Toggle */}
// // // //           <Box display="flex" gap={1}>
// // // //             <Button
// // // //               variant={isAdd ? 'contained' : 'outlined'} color="primary"
// // // //               startIcon={<PersonAddIcon />} onClick={() => setMode('add')}
// // // //               disabled={submitting} size="small" sx={{ flex: 1 }}
// // // //             >Add Permission</Button>
// // // //             <Button
// // // //               variant={!isAdd ? 'contained' : 'outlined'} color="error"
// // // //               startIcon={<PersonRemoveIcon />} onClick={() => setMode('remove')}
// // // //               disabled={submitting} size="small" sx={{ flex: 1 }}
// // // //             >Remove Permission</Button>
// // // //           </Box>


// // // //           {/* Reference ID Range */}
// // // //           <Box>
// // // //             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// // // //               Reference ID Range
// // // //             </Typography>
// // // //             <Box display="flex" gap={2}>
// // // //               <TextField
// // // //                 fullWidth size="small" label="From Reference ID"
// // // //                 value={startRefId} onChange={e => setStartRefId(e.target.value)}
// // // //                 disabled={submitting}
// // // //               />
// // // //               <TextField
// // // //                 fullWidth size="small" label="To Reference ID"
// // // //                 value={endRefId} onChange={e => setEndRefId(e.target.value)}
// // // //                 disabled={submitting}
// // // //               />
// // // //             </Box>


// // // //             {startRefId && endRefId && (
// // // //               <Box mt={1}>
// // // //                 {(Array.isArray(rangePreview) && rangePreview.length > 0) ? (
// // // //                   <Alert severity={isAdd ? 'info' : 'warning'} sx={{ py: 0.5 }}>
// // // //                     <strong>{rangePreview.length} record(s)</strong> matched —{' '}
// // // //                     {rangePreview.slice(0, 3).map(r => r.reference_id).join(', ')}
// // // //                     {rangePreview.length > 3 && ` ... +${rangePreview.length - 3} more`}
// // // //                   </Alert>
// // // //                 ) : (
// // // //                   <Alert severity="error" sx={{ py: 0.5 }}>No records match this range.</Alert>
// // // //                 )}
// // // //               </Box>
// // // //             )}
// // // //           </Box>


// // // //           {/* SHR Name Search */}
// // // //           {isAdd && (
// // // //             <Box>
// // // //               <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// // // //                 Authorized SHR Name <Typography component="span" color="error">*</Typography>
// // // //               </Typography>
// // // //               <TextField
// // // //                 fullWidth size="small"
// // // //                 placeholder="Type email or name to search..."
// // // //                 value={shrSearch}
// // // //                 onChange={e => setShrSearch(e.target.value)}
// // // //                 disabled={submitting || loadingUsers}
// // // //                 required
// // // //                 InputProps={{
// // // //                   startAdornment: loadingUsers ? <CircularProgress size={16} sx={{ mr: 1 }} /> : <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.disabled' }} />,
// // // //                   endAdornment: shrSearch && (
// // // //                     <IconButton size="small" onClick={() => { setShrSearch(''); setPickedShr(null); setShrName(''); }}>
// // // //                       <CloseIcon fontSize="small" />
// // // //                     </IconButton>
// // // //                   ),
// // // //                 }}
// // // //               />


// // // //               {(Array.isArray(shrFilteredUsers) && shrFilteredUsers.length > 0) && (
// // // //                 <Box sx={{ mt: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, maxHeight: 180, overflow: 'auto' }}>
// // // //                   {shrFilteredUsers.map((user, idx) => {
// // // //                     const isPicked = pickedShr?.id === user.id;
// // // //                     return (
// // // //                       <Box
// // // //                         key={user.id}
// // // //                         onClick={() => toggleShr(user)}
// // // //                         sx={{
// // // //                           display: 'flex', alignItems: 'center', gap: 1.5,
// // // //                           px: 2, py: 1, cursor: 'pointer',
// // // //                           bgcolor: isPicked ? 'primary.50' : 'transparent',
// // // //                           borderBottom: idx < shrFilteredUsers.length - 1 ? '1px solid' : 'none',
// // // //                           borderColor: 'divider',
// // // //                           '&:hover': { bgcolor: isPicked ? 'primary.100' : 'action.hover' },
// // // //                           transition: 'background 0.15s',
// // // //                         }}
// // // //                       >
// // // //                         <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: isPicked ? 'primary.main' : 'grey.400' }}>
// // // //                           {user.name?.[0]?.toUpperCase() || '?'}
// // // //                         </Avatar>
// // // //                         <Box flex={1} minWidth={0}>
// // // //                           <Typography variant="body2" fontWeight={isPicked ? 600 : 400} noWrap>{user.name}</Typography>
// // // //                           <Typography variant="caption" color="text.secondary" noWrap>{user.email}</Typography>
// // // //                         </Box>
// // // //                         {isPicked && <CheckCircleIcon fontSize="small" color="primary" />}
// // // //                       </Box>
// // // //                     );
// // // //                   })}
// // // //                 </Box>
// // // //               )}


// // // //               {pickedShr && (
// // // //                 <Box mt={1}>
// // // //                   <Chip
// // // //                     label={pickedShr.name}
// // // //                     size="small"
// // // //                     avatar={
// // // //                       <Avatar sx={{ bgcolor: 'primary.main', fontSize: 11 }}>
// // // //                         {pickedShr.name?.[0]?.toUpperCase()}
// // // //                       </Avatar>
// // // //                     }
// // // //                     onDelete={() => { setPickedShr(null); setShrSearch(''); setShrName(''); }}
// // // //                     color="primary"
// // // //                     variant="outlined"
// // // //                   />
// // // //                 </Box>
// // // //               )}
// // // //             </Box>
// // // //           )}


// // // //           {/* Forensic Auditor Search — mandatory, multi-select like Users */}
// // // //           {isAdd && (
// // // //             <Box>
// // // //               <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// // // //                 Forensic Auditor(s) <Typography component="span" color="error">*</Typography>
// // // //               </Typography>
// // // //               <TextField
// // // //                 fullWidth size="small"
// // // //                 placeholder="Type email or name to search..."
// // // //                 value={forensicSearch}
// // // //                 onChange={e => setForensicSearch(e.target.value)}
// // // //                 disabled={submitting || loadingUsers}
// // // //                 required
// // // //                 InputProps={{
// // // //                   startAdornment: loadingUsers ? <CircularProgress size={16} sx={{ mr: 1 }} /> : <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.disabled' }} />,
// // // //                   endAdornment: forensicSearch && (
// // // //                     <IconButton size="small" onClick={() => setForensicSearch('')}>
// // // //                       <CloseIcon fontSize="small" />
// // // //                     </IconButton>
// // // //                   ),
// // // //                 }}
// // // //               />


// // // //               {(Array.isArray(filteredForensicUsers) && filteredForensicUsers.length > 0) && (
// // // //                 <Box sx={{ mt: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, maxHeight: 180, overflow: 'auto' }}>
// // // //                   {filteredForensicUsers.map((user, idx) => {
// // // //                     const isPicked = pickedForensic.some(u => u.id === user.id);
// // // //                     return (
// // // //                       <Box
// // // //                         key={user.id}
// // // //                         onClick={() => toggleForensic(user)}
// // // //                         sx={{
// // // //                           display: 'flex', alignItems: 'center', gap: 1.5,
// // // //                           px: 2, py: 1, cursor: 'pointer',
// // // //                           bgcolor: isPicked ? 'primary.50' : 'transparent',
// // // //                           borderBottom: idx < filteredForensicUsers.length - 1 ? '1px solid' : 'none',
// // // //                           borderColor: 'divider',
// // // //                           '&:hover': { bgcolor: isPicked ? 'primary.100' : 'action.hover' },
// // // //                           transition: 'background 0.15s',
// // // //                         }}
// // // //                       >
// // // //                         <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: isPicked ? 'primary.main' : 'grey.400' }}>
// // // //                           {user.name?.[0]?.toUpperCase() || '?'}
// // // //                         </Avatar>
// // // //                         <Box flex={1} minWidth={0}>
// // // //                           <Typography variant="body2" fontWeight={isPicked ? 600 : 400} noWrap>{user.name}</Typography>
// // // //                           <Typography variant="caption" color="text.secondary" noWrap>{user.email}</Typography>
// // // //                         </Box>
// // // //                         {isPicked && <CheckCircleIcon fontSize="small" color="primary" />}
// // // //                       </Box>
// // // //                     );
// // // //                   })}
// // // //                 </Box>
// // // //               )}


// // // //               {(Array.isArray(pickedForensic) && pickedForensic.length > 0) && (
// // // //                 <Box mt={1} display="flex" flexWrap="wrap" gap={0.75}>
// // // //                   {pickedForensic.map(user => (
// // // //                     <Chip
// // // //                       key={user.id}
// // // //                       label={user.email}
// // // //                       size="small"
// // // //                       avatar={
// // // //                         <Avatar sx={{ bgcolor: 'primary.main', fontSize: 11 }}>
// // // //                           {user.name?.[0]?.toUpperCase()}
// // // //                         </Avatar>
// // // //                       }
// // // //                       onDelete={() => setPickedForensic(prev => prev.filter(u => u.id !== user.id))}
// // // //                       color="primary"
// // // //                       variant="outlined"
// // // //                     />
// // // //                   ))}
// // // //                 </Box>
// // // //               )}
// // // //             </Box>
// // // //           )}


// // // //           {/* User Search */}
// // // //           <Box>
// // // //             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// // // //               Search &amp; Select Users by Email
// // // //             </Typography>
// // // //             <TextField
// // // //               fullWidth size="small"
// // // //               placeholder="Type email or name to search..."
// // // //               value={searchEmail}
// // // //               onChange={e => setSearchEmail(e.target.value)}
// // // //               disabled={submitting || loadingUsers}
// // // //               InputProps={{
// // // //                 startAdornment: loadingUsers ? <CircularProgress size={16} sx={{ mr: 1 }} /> : <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.disabled' }} />,
// // // //                 endAdornment: searchEmail && (
// // // //                   <IconButton size="small" onClick={() => setSearchEmail('')}>
// // // //                     <CloseIcon fontSize="small" />
// // // //                   </IconButton>
// // // //                 ),
// // // //               }}
// // // //             />


// // // //             {(Array.isArray(filteredUsers) && filteredUsers.length > 0) && (
// // // //               <Box sx={{ mt: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, maxHeight: 180, overflow: 'auto' }}>
// // // //                 {filteredUsers.map((user, idx) => {
// // // //                   const isPicked = pickedUsers.some(u => u.id === user.id);
// // // //                   return (
// // // //                     <Box
// // // //                       key={user.id}
// // // //                       onClick={() => toggleUser(user)}
// // // //                       sx={{
// // // //                         display: 'flex', alignItems: 'center', gap: 1.5,
// // // //                         px: 2, py: 1, cursor: 'pointer',
// // // //                         bgcolor: isPicked ? 'primary.50' : 'transparent',
// // // //                         borderBottom: idx < filteredUsers.length - 1 ? '1px solid' : 'none',
// // // //                         borderColor: 'divider',
// // // //                         '&:hover': { bgcolor: isPicked ? 'primary.100' : 'action.hover' },
// // // //                         transition: 'background 0.15s',
// // // //                       }}
// // // //                     >
// // // //                       <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: isPicked ? 'primary.main' : 'grey.400' }}>
// // // //                         {user.name?.[0]?.toUpperCase() || '?'}
// // // //                       </Avatar>
// // // //                       <Box flex={1} minWidth={0}>
// // // //                         <Typography variant="body2" fontWeight={isPicked ? 600 : 400} noWrap>{user.name}</Typography>
// // // //                         <Typography variant="caption" color="text.secondary" noWrap>{user.email}</Typography>
// // // //                       </Box>
// // // //                       {isPicked && <CheckCircleIcon fontSize="small" color="primary" />}
// // // //                     </Box>
// // // //                   );
// // // //                 })}
// // // //               </Box>
// // // //             )}
// // // //           </Box>


// // // //           {/* Picked Users Chips */}
// // // //           {(Array.isArray(pickedUsers) && pickedUsers.length > 0) && (
// // // //             <Box>
// // // //               <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// // // //                 Selected Users ({pickedUsers.length})
// // // //               </Typography>
// // // //               <Box display="flex" flexWrap="wrap" gap={0.75}>
// // // //                 {pickedUsers.map(user => (
// // // //                   <Chip
// // // //                     key={user.id}
// // // //                     label={user.email}
// // // //                     size="small"
// // // //                     avatar={
// // // //                       <Avatar sx={{ bgcolor: isAdd ? 'primary.main' : 'error.main', fontSize: 11 }}>
// // // //                         {user.name?.[0]?.toUpperCase()}
// // // //                       </Avatar>
// // // //                     }
// // // //                     onDelete={() => setPickedUsers(prev => prev.filter(u => u.id !== user.id))}
// // // //                     color={isAdd ? 'primary' : 'error'}
// // // //                     variant="outlined"
// // // //                   />
// // // //                 ))}
// // // //               </Box>
// // // //             </Box>
// // // //           )}


// // // //           {/* Summary */}
// // // //           {(Array.isArray(rangePreview) && rangePreview.length > 0 && Array.isArray(pickedUsers) && pickedUsers.length > 0) && (
// // // //             <Alert severity={isAdd ? 'success' : 'warning'} sx={{ py: 0.5 }}>
// // // //               {isAdd
// // // //                 ? `Will grant ${pickedUsers.length} user(s) access to ${rangePreview.length} record(s).`
// // // //                 : `Will revoke ${pickedUsers.length} user(s) access from ${rangePreview.length} record(s).`}
// // // //             </Alert>
// // // //           )}
// // // //         </Box>
// // // //       </DialogContent>


// // // //       <Divider />


// // // //       <DialogActions sx={{ px: 3, py: 2 }}>
// // // //         <Button onClick={handleClose} disabled={submitting}>Cancel</Button>
// // // //         <Button
// // // //           onClick={handleSubmit}
// // // //           variant="contained"
// // // //           color={isAdd ? 'primary' : 'error'}
// // // //           disabled={
// // // //             submitting ||
// // // //             !Array.isArray(rangePreview) || rangePreview.length === 0 ||
// // // //             !Array.isArray(pickedUsers) || pickedUsers.length === 0 ||
// // // //             (isAdd && !shrName.trim()) ||
// // // //             (isAdd && (!Array.isArray(pickedForensic) || pickedForensic.length === 0))
// // // //           }
// // // //           startIcon={submitting
// // // //             ? <CircularProgress size={16} color="inherit" />
// // // //             : isAdd ? <PersonAddIcon /> : <PersonRemoveIcon />}
// // // //         >
// // // //           {submitting
// // // //             ? 'Processing...'
// // // //             : isAdd
// // // //               ? `Grant to ${rangePreview.length} Record(s)`
// // // //               : `Revoke from ${rangePreview.length} Record(s)`}
// // // //         </Button>
// // // //       </DialogActions>
// // // //     </Dialog>
// // // //   );
// // // // };

// // // import React, { useState, useEffect, useCallback } from 'react';
// // // import {
// // //   Dialog,
// // //   DialogTitle,
// // //   DialogContent,
// // //   DialogActions,
// // //   Button,
// // //   Box,
// // //   Typography,
// // //   TextField,
// // //   Chip,
// // //   Avatar,
// // //   IconButton,
// // //   CircularProgress,
// // //   Divider,
// // //   Alert,
// // // } from '@mui/material';
// // // import {
// // //   Search as SearchIcon,
// // //   Close as CloseIcon,
// // //   PersonAdd as PersonAddIcon,
// // //   PersonRemove as PersonRemoveIcon,
// // //   CheckCircle as CheckCircleIcon,
// // // } from '@mui/icons-material';
// // // import api from '../../../api/axiosInterceptor';


// // // export const BulkPermissionDialog = ({ open, onClose, rows, onSuccess, onError }) => {
// // //   const [mode, setMode] = useState('add'); // 'add' | 'remove'
// // //   const [startRefId, setStartRefId] = useState('');
// // //   const [endRefId, setEndRefId] = useState('');
// // //   const [rangePreview, setRangePreview] = useState([]);
// // //   const [allUsers, setAllUsers] = useState([]);
// // //   const [searchEmail, setSearchEmail] = useState('');
// // //   const [filteredUsers, setFilteredUsers] = useState([]);
// // //   const [pickedUsers, setPickedUsers] = useState([]);
// // //   const [loadingUsers, setLoadingUsers] = useState(false);
// // //   const [shrName, setShrName] = useState('');
// // //   const [shrSearch, setShrSearch] = useState('');
// // //   const [shrFilteredUsers, setShrFilteredUsers] = useState([]);
// // //   const [pickedShr, setPickedShr] = useState(null);

// // //   // Forensic Auditor — multi-select, mandatory in BOTH add and remove modes
// // //   const [forensicSearch, setForensicSearch] = useState('');
// // //   const [filteredForensicUsers, setFilteredForensicUsers] = useState([]);
// // //   const [pickedForensic, setPickedForensic] = useState([]);

// // //   const [submitting, setSubmitting] = useState(false);


// // //   // Fetch users on open
// // //   useEffect(() => {
// // //     if (!open) return;
// // //     setLoadingUsers(true);
// // //     api.get('/auth/role-mgmt/')
// // //       .then(res => {
// // //         const usersArray = Array.isArray(res.data) ? res.data : res.data?.users || [];
// // //         setAllUsers(usersArray);
// // //       })
// // //       .catch(() => onError('Failed to load users.'))
// // //       .finally(() => setLoadingUsers(false));
// // //   }, [open, onError]);


// // //   // Range preview
// // //   useEffect(() => {
// // //     if (!startRefId || !endRefId || !Array.isArray(rows) || rows.length === 0) {
// // //       setRangePreview([]);
// // //       return;
// // //     }
// // //     const sorted = [...rows].sort((a, b) => a.reference_id.localeCompare(b.reference_id));
// // //     setRangePreview(sorted.filter(r => r.reference_id >= startRefId && r.reference_id <= endRefId));
// // //   }, [startRefId, endRefId, rows]);


// // //   // Filter users for regular search
// // //   useEffect(() => {
// // //     if (!searchEmail.trim()) {
// // //       setFilteredUsers([]);
// // //       return;
// // //     }
// // //     const q = searchEmail.toLowerCase();
// // //     setFilteredUsers(
// // //       (Array.isArray(allUsers) ? allUsers : []).filter(
// // //         u => u.email?.toLowerCase().includes(q) || u.name?.toLowerCase().includes(q)
// // //       ).slice(0, 8)
// // //     );
// // //   }, [searchEmail, allUsers]);


// // //   // Filter users for SHR search
// // //   useEffect(() => {
// // //     if (!shrSearch.trim()) {
// // //       setShrFilteredUsers([]);
// // //       return;
// // //     }
// // //     const q = shrSearch.toLowerCase();
// // //     setShrFilteredUsers(
// // //       (Array.isArray(allUsers) ? allUsers : []).filter(
// // //         u => u.email?.toLowerCase().includes(q) || u.name?.toLowerCase().includes(q)
// // //       ).slice(0, 8)
// // //     );
// // //   }, [shrSearch, allUsers]);


// // //   // Filter users for Forensic Auditor search
// // //   useEffect(() => {
// // //     if (!forensicSearch.trim()) {
// // //       setFilteredForensicUsers([]);
// // //       return;
// // //     }
// // //     const q = forensicSearch.toLowerCase();
// // //     setFilteredForensicUsers(
// // //       (Array.isArray(allUsers) ? allUsers : []).filter(
// // //         u => u.email?.toLowerCase().includes(q) || u.name?.toLowerCase().includes(q)
// // //       ).slice(0, 8)
// // //     );
// // //   }, [forensicSearch, allUsers]);


// // //   const handleClose = useCallback(() => {
// // //     setStartRefId('');
// // //     setEndRefId('');
// // //     setRangePreview([]);
// // //     setSearchEmail('');
// // //     setFilteredUsers([]);
// // //     setPickedUsers([]);
// // //     setShrName('');
// // //     setShrSearch('');
// // //     setShrFilteredUsers([]);
// // //     setPickedShr(null);
// // //     setForensicSearch('');
// // //     setFilteredForensicUsers([]);
// // //     setPickedForensic([]);
// // //     setMode('add');
// // //     onClose();
// // //   }, [onClose]);


// // //   const toggleUser = (user) => {
// // //     setPickedUsers(prev =>
// // //       prev.some(u => u.id === user.id)
// // //         ? prev.filter(u => u.id !== user.id)
// // //         : [...prev, user]
// // //     );
// // //   };


// // //   const toggleShr = (user) => {
// // //     if (pickedShr?.id === user.id) {
// // //       setPickedShr(null);
// // //       setShrName('');
// // //     } else {
// // //       setPickedShr(user);
// // //       setShrName(user.name || '');
// // //     }
// // //   };


// // //   const toggleForensic = (user) => {
// // //     setPickedForensic(prev =>
// // //       prev.some(u => u.id === user.id)
// // //         ? prev.filter(u => u.id !== user.id)
// // //         : [...prev, user]
// // //     );
// // //   };


// // //   const handleSubmit = async () => {
// // //     if (!Array.isArray(rangePreview) || rangePreview.length === 0) {
// // //       onError('No records match the entered range.');
// // //       return;
// // //     }
// // //     if (!Array.isArray(pickedUsers) || pickedUsers.length === 0) {
// // //       onError('Please select at least one user.');
// // //       return;
// // //     }
// // //     if (mode === 'add' && !shrName.trim()) {
// // //       onError('SHR Name is required.');
// // //       return;
// // //     }
// // //     // Mandatory in BOTH add and remove modes
// // //     if (!Array.isArray(pickedForensic) || pickedForensic.length === 0) {
// // //       onError('Please select at least one Forensic Auditor.');
// // //       return;
// // //     }

// // //     const payload = {
// // //       excess_ids: rangePreview.map(r => r.id),
// // //       user_ids: pickedUsers.map(u => u.id),
// // //       forensic_auditor_ids: pickedForensic.map(u => u.id), // always sent, both modes
// // //       ...(mode === 'add' && shrName.trim() ? { shr_name: shrName.trim() } : {}),
// // //     };

// // //     try {
// // //       setSubmitting(true);
// // //       if (mode === 'add') {
// // //         const res = await api.post('/excess_payment_mgmt/excess/bulk-permission/', payload);
// // //         onSuccess(`Permissions added. Created: ${res.data.created_count}, Skipped: ${res.data.skipped_count}.`);
// // //       } else {
// // //         const res = await api.delete('/excess_payment_mgmt/excess/bulk-permission/', { data: payload });
// // //         onSuccess(`Permissions removed. Deleted: ${res.data.deleted_count}.`);
// // //       }
// // //       handleClose();
// // //     } catch (err) {
// // //       onError(err?.response?.data?.error || 'Failed to update permissions.');
// // //     } finally {
// // //       setSubmitting(false);
// // //     }
// // //   };


// // //   const isAdd = mode === 'add';


// // //   return (
// // //     <Dialog open={open} onClose={!submitting ? handleClose : undefined} maxWidth="sm" fullWidth>
// // //       <DialogTitle sx={{ pb: 1 }}>
// // //         <Box display="flex" justifyContent="space-between" alignItems="center">
// // //           <Typography variant="h6" fontWeight="bold">Bulk Permission Management</Typography>
// // //           <IconButton size="small" onClick={handleClose} disabled={submitting}>
// // //             <CloseIcon fontSize="small" />
// // //           </IconButton>
// // //         </Box>
// // //       </DialogTitle>
// // //       <Divider />
// // //       <DialogContent sx={{ pt: 2 }}>
// // //         <Box display="flex" flexDirection="column" gap={2.5}>
// // //           {/* Mode Toggle */}
// // //           <Box display="flex" gap={1}>
// // //             <Button
// // //               variant={isAdd ? 'contained' : 'outlined'} color="primary"
// // //               startIcon={<PersonAddIcon />} onClick={() => setMode('add')}
// // //               disabled={submitting} size="small" sx={{ flex: 1 }}
// // //             >Add Permission</Button>
// // //             <Button
// // //               variant={!isAdd ? 'contained' : 'outlined'} color="error"
// // //               startIcon={<PersonRemoveIcon />} onClick={() => setMode('remove')}
// // //               disabled={submitting} size="small" sx={{ flex: 1 }}
// // //             >Remove Permission</Button>
// // //           </Box>


// // //           {/* Reference ID Range */}
// // //           <Box>
// // //             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// // //               Reference ID Range
// // //             </Typography>
// // //             <Box display="flex" gap={2}>
// // //               <TextField
// // //                 fullWidth size="small" label="From Reference ID"
// // //                 value={startRefId} onChange={e => setStartRefId(e.target.value)}
// // //                 disabled={submitting}
// // //               />
// // //               <TextField
// // //                 fullWidth size="small" label="To Reference ID"
// // //                 value={endRefId} onChange={e => setEndRefId(e.target.value)}
// // //                 disabled={submitting}
// // //               />
// // //             </Box>


// // //             {startRefId && endRefId && (
// // //               <Box mt={1}>
// // //                 {(Array.isArray(rangePreview) && rangePreview.length > 0) ? (
// // //                   <Alert severity={isAdd ? 'info' : 'warning'} sx={{ py: 0.5 }}>
// // //                     <strong>{rangePreview.length} record(s)</strong> matched —{' '}
// // //                     {rangePreview.slice(0, 3).map(r => r.reference_id).join(', ')}
// // //                     {rangePreview.length > 3 && ` ... +${rangePreview.length - 3} more`}
// // //                   </Alert>
// // //                 ) : (
// // //                   <Alert severity="error" sx={{ py: 0.5 }}>No records match this range.</Alert>
// // //                 )}
// // //               </Box>
// // //             )}
// // //           </Box>


// // //           {/* SHR Name Search — Add mode only */}
// // //           {isAdd && (
// // //             <Box>
// // //               <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// // //                 Authorized SHR Name <Typography component="span" color="error">*</Typography>
// // //               </Typography>
// // //               <TextField
// // //                 fullWidth size="small"
// // //                 placeholder="Type email or name to search..."
// // //                 value={shrSearch}
// // //                 onChange={e => setShrSearch(e.target.value)}
// // //                 disabled={submitting || loadingUsers}
// // //                 required
// // //                 InputProps={{
// // //                   startAdornment: loadingUsers ? <CircularProgress size={16} sx={{ mr: 1 }} /> : <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.disabled' }} />,
// // //                   endAdornment: shrSearch && (
// // //                     <IconButton size="small" onClick={() => { setShrSearch(''); setPickedShr(null); setShrName(''); }}>
// // //                       <CloseIcon fontSize="small" />
// // //                     </IconButton>
// // //                   ),
// // //                 }}
// // //               />


// // //               {(Array.isArray(shrFilteredUsers) && shrFilteredUsers.length > 0) && (
// // //                 <Box sx={{ mt: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, maxHeight: 180, overflow: 'auto' }}>
// // //                   {shrFilteredUsers.map((user, idx) => {
// // //                     const isPicked = pickedShr?.id === user.id;
// // //                     return (
// // //                       <Box
// // //                         key={user.id}
// // //                         onClick={() => toggleShr(user)}
// // //                         sx={{
// // //                           display: 'flex', alignItems: 'center', gap: 1.5,
// // //                           px: 2, py: 1, cursor: 'pointer',
// // //                           bgcolor: isPicked ? 'primary.50' : 'transparent',
// // //                           borderBottom: idx < shrFilteredUsers.length - 1 ? '1px solid' : 'none',
// // //                           borderColor: 'divider',
// // //                           '&:hover': { bgcolor: isPicked ? 'primary.100' : 'action.hover' },
// // //                           transition: 'background 0.15s',
// // //                         }}
// // //                       >
// // //                         <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: isPicked ? 'primary.main' : 'grey.400' }}>
// // //                           {user.name?.[0]?.toUpperCase() || '?'}
// // //                         </Avatar>
// // //                         <Box flex={1} minWidth={0}>
// // //                           <Typography variant="body2" fontWeight={isPicked ? 600 : 400} noWrap>{user.name}</Typography>
// // //                           <Typography variant="caption" color="text.secondary" noWrap>{user.email}</Typography>
// // //                         </Box>
// // //                         {isPicked && <CheckCircleIcon fontSize="small" color="primary" />}
// // //                       </Box>
// // //                     );
// // //                   })}
// // //                 </Box>
// // //               )}


// // //               {pickedShr && (
// // //                 <Box mt={1}>
// // //                   <Chip
// // //                     label={pickedShr.name}
// // //                     size="small"
// // //                     avatar={
// // //                       <Avatar sx={{ bgcolor: 'primary.main', fontSize: 11 }}>
// // //                         {pickedShr.name?.[0]?.toUpperCase()}
// // //                       </Avatar>
// // //                     }
// // //                     onDelete={() => { setPickedShr(null); setShrSearch(''); setShrName(''); }}
// // //                     color="primary"
// // //                     variant="outlined"
// // //                   />
// // //                 </Box>
// // //               )}
// // //             </Box>
// // //           )}


// // //           {/* Forensic Auditor Search — mandatory in BOTH Add and Remove modes */}
// // //           <Box>
// // //             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// // //               Forensic Auditor(s) <Typography component="span" color="error">*</Typography>
// // //             </Typography>
// // //             <TextField
// // //               fullWidth size="small"
// // //               placeholder="Type email or name to search..."
// // //               value={forensicSearch}
// // //               onChange={e => setForensicSearch(e.target.value)}
// // //               disabled={submitting || loadingUsers}
// // //               required
// // //               InputProps={{
// // //                 startAdornment: loadingUsers ? <CircularProgress size={16} sx={{ mr: 1 }} /> : <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.disabled' }} />,
// // //                 endAdornment: forensicSearch && (
// // //                   <IconButton size="small" onClick={() => setForensicSearch('')}>
// // //                     <CloseIcon fontSize="small" />
// // //                   </IconButton>
// // //                 ),
// // //               }}
// // //             />


// // //             {(Array.isArray(filteredForensicUsers) && filteredForensicUsers.length > 0) && (
// // //               <Box sx={{ mt: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, maxHeight: 180, overflow: 'auto' }}>
// // //                 {filteredForensicUsers.map((user, idx) => {
// // //                   const isPicked = pickedForensic.some(u => u.id === user.id);
// // //                   return (
// // //                     <Box
// // //                       key={user.id}
// // //                       onClick={() => toggleForensic(user)}
// // //                       sx={{
// // //                         display: 'flex', alignItems: 'center', gap: 1.5,
// // //                         px: 2, py: 1, cursor: 'pointer',
// // //                         bgcolor: isPicked ? 'primary.50' : 'transparent',
// // //                         borderBottom: idx < filteredForensicUsers.length - 1 ? '1px solid' : 'none',
// // //                         borderColor: 'divider',
// // //                         '&:hover': { bgcolor: isPicked ? 'primary.100' : 'action.hover' },
// // //                         transition: 'background 0.15s',
// // //                       }}
// // //                     >
// // //                       <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: isPicked ? 'primary.main' : 'grey.400' }}>
// // //                         {user.name?.[0]?.toUpperCase() || '?'}
// // //                       </Avatar>
// // //                       <Box flex={1} minWidth={0}>
// // //                         <Typography variant="body2" fontWeight={isPicked ? 600 : 400} noWrap>{user.name}</Typography>
// // //                         <Typography variant="caption" color="text.secondary" noWrap>{user.email}</Typography>
// // //                       </Box>
// // //                       {isPicked && <CheckCircleIcon fontSize="small" color="primary" />}
// // //                     </Box>
// // //                   );
// // //                 })}
// // //               </Box>
// // //             )}


// // //             {(Array.isArray(pickedForensic) && pickedForensic.length > 0) && (
// // //               <Box mt={1} display="flex" flexWrap="wrap" gap={0.75}>
// // //                 {pickedForensic.map(user => (
// // //                   <Chip
// // //                     key={user.id}
// // //                     label={user.email}
// // //                     size="small"
// // //                     avatar={
// // //                       <Avatar sx={{ bgcolor: 'primary.main', fontSize: 11 }}>
// // //                         {user.name?.[0]?.toUpperCase()}
// // //                       </Avatar>
// // //                     }
// // //                     onDelete={() => setPickedForensic(prev => prev.filter(u => u.id !== user.id))}
// // //                     color="primary"
// // //                     variant="outlined"
// // //                   />
// // //                 ))}
// // //               </Box>
// // //             )}
// // //           </Box>


// // //           {/* User Search */}
// // //           <Box>
// // //             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// // //               Search &amp; Select Users by Email
// // //             </Typography>
// // //             <TextField
// // //               fullWidth size="small"
// // //               placeholder="Type email or name to search..."
// // //               value={searchEmail}
// // //               onChange={e => setSearchEmail(e.target.value)}
// // //               disabled={submitting || loadingUsers}
// // //               InputProps={{
// // //                 startAdornment: loadingUsers ? <CircularProgress size={16} sx={{ mr: 1 }} /> : <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.disabled' }} />,
// // //                 endAdornment: searchEmail && (
// // //                   <IconButton size="small" onClick={() => setSearchEmail('')}>
// // //                     <CloseIcon fontSize="small" />
// // //                   </IconButton>
// // //                 ),
// // //               }}
// // //             />


// // //             {(Array.isArray(filteredUsers) && filteredUsers.length > 0) && (
// // //               <Box sx={{ mt: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, maxHeight: 180, overflow: 'auto' }}>
// // //                 {filteredUsers.map((user, idx) => {
// // //                   const isPicked = pickedUsers.some(u => u.id === user.id);
// // //                   return (
// // //                     <Box
// // //                       key={user.id}
// // //                       onClick={() => toggleUser(user)}
// // //                       sx={{
// // //                         display: 'flex', alignItems: 'center', gap: 1.5,
// // //                         px: 2, py: 1, cursor: 'pointer',
// // //                         bgcolor: isPicked ? 'primary.50' : 'transparent',
// // //                         borderBottom: idx < filteredUsers.length - 1 ? '1px solid' : 'none',
// // //                         borderColor: 'divider',
// // //                         '&:hover': { bgcolor: isPicked ? 'primary.100' : 'action.hover' },
// // //                         transition: 'background 0.15s',
// // //                       }}
// // //                     >
// // //                       <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: isPicked ? 'primary.main' : 'grey.400' }}>
// // //                         {user.name?.[0]?.toUpperCase() || '?'}
// // //                       </Avatar>
// // //                       <Box flex={1} minWidth={0}>
// // //                         <Typography variant="body2" fontWeight={isPicked ? 600 : 400} noWrap>{user.name}</Typography>
// // //                         <Typography variant="caption" color="text.secondary" noWrap>{user.email}</Typography>
// // //                       </Box>
// // //                       {isPicked && <CheckCircleIcon fontSize="small" color="primary" />}
// // //                     </Box>
// // //                   );
// // //                 })}
// // //               </Box>
// // //             )}
// // //           </Box>


// // //           {/* Picked Users Chips */}
// // //           {(Array.isArray(pickedUsers) && pickedUsers.length > 0) && (
// // //             <Box>
// // //               <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// // //                 Selected Users ({pickedUsers.length})
// // //               </Typography>
// // //               <Box display="flex" flexWrap="wrap" gap={0.75}>
// // //                 {pickedUsers.map(user => (
// // //                   <Chip
// // //                     key={user.id}
// // //                     label={user.email}
// // //                     size="small"
// // //                     avatar={
// // //                       <Avatar sx={{ bgcolor: isAdd ? 'primary.main' : 'error.main', fontSize: 11 }}>
// // //                         {user.name?.[0]?.toUpperCase()}
// // //                       </Avatar>
// // //                     }
// // //                     onDelete={() => setPickedUsers(prev => prev.filter(u => u.id !== user.id))}
// // //                     color={isAdd ? 'primary' : 'error'}
// // //                     variant="outlined"
// // //                   />
// // //                 ))}
// // //               </Box>
// // //             </Box>
// // //           )}


// // //           {/* Summary */}
// // //           {(Array.isArray(rangePreview) && rangePreview.length > 0 && Array.isArray(pickedUsers) && pickedUsers.length > 0) && (
// // //             <Alert severity={isAdd ? 'success' : 'warning'} sx={{ py: 0.5 }}>
// // //               {isAdd
// // //                 ? `Will grant ${pickedUsers.length} user(s) access to ${rangePreview.length} record(s).`
// // //                 : `Will revoke ${pickedUsers.length} user(s) access from ${rangePreview.length} record(s).`}
// // //             </Alert>
// // //           )}
// // //         </Box>
// // //       </DialogContent>


// // //       <Divider />


// // //       <DialogActions sx={{ px: 3, py: 2 }}>
// // //         <Button onClick={handleClose} disabled={submitting}>Cancel</Button>
// // //         <Button
// // //           onClick={handleSubmit}
// // //           variant="contained"
// // //           color={isAdd ? 'primary' : 'error'}
// // //           disabled={
// // //             submitting ||
// // //             !Array.isArray(rangePreview) || rangePreview.length === 0 ||
// // //             !Array.isArray(pickedUsers) || pickedUsers.length === 0 ||
// // //             (isAdd && !shrName.trim()) ||
// // //             !Array.isArray(pickedForensic) || pickedForensic.length === 0
// // //           }
// // //           startIcon={submitting
// // //             ? <CircularProgress size={16} color="inherit" />
// // //             : isAdd ? <PersonAddIcon /> : <PersonRemoveIcon />}
// // //         >
// // //           {submitting
// // //             ? 'Processing...'
// // //             : isAdd
// // //               ? `Grant to ${rangePreview.length} Record(s)`
// // //               : `Revoke from ${rangePreview.length} Record(s)`}
// // //         </Button>
// // //       </DialogActions>
// // //     </Dialog>
// // //   );
// // // };


// // import React, { useState, useEffect, useCallback } from 'react';
// // import {
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   Button,
// //   Box,
// //   Typography,
// //   TextField,
// //   Chip,
// //   Avatar,
// //   IconButton,
// //   CircularProgress,
// //   Divider,
// //   Alert,
// // } from '@mui/material';
// // import {
// //   Search as SearchIcon,
// //   Close as CloseIcon,
// //   PersonAdd as PersonAddIcon,
// //   PersonRemove as PersonRemoveIcon,
// //   CheckCircle as CheckCircleIcon,
// // } from '@mui/icons-material';
// // import api from '../../../api/axiosInterceptor';


// // export const BulkPermissionDialog = ({ open, onClose, rows, onSuccess, onError }) => {
// //   const [mode, setMode] = useState('add'); // 'add' | 'remove'
// //   const [startRefId, setStartRefId] = useState('');
// //   const [endRefId, setEndRefId] = useState('');
// //   const [rangePreview, setRangePreview] = useState([]);
// //   const [allUsers, setAllUsers] = useState([]);
// //   const [searchEmail, setSearchEmail] = useState('');
// //   const [filteredUsers, setFilteredUsers] = useState([]);
// //   const [pickedUsers, setPickedUsers] = useState([]);
// //   const [loadingUsers, setLoadingUsers] = useState(false);
// //   const [shrName, setShrName] = useState('');
// //   const [shrSearch, setShrSearch] = useState('');
// //   const [shrFilteredUsers, setShrFilteredUsers] = useState([]);
// //   const [pickedShr, setPickedShr] = useState(null);

// //   // Forensic Auditor — multi-select, mandatory in BOTH add and remove modes
// //   const [forensicSearch, setForensicSearch] = useState('');
// //   const [filteredForensicUsers, setFilteredForensicUsers] = useState([]);
// //   const [pickedForensic, setPickedForensic] = useState([]);

// //   const [submitting, setSubmitting] = useState(false);


// //   // Fetch users on open
// //   useEffect(() => {
// //     if (!open) return;
// //     setLoadingUsers(true);
// //     api.get('/auth/role-mgmt/')
// //       .then(res => {
// //         const usersArray = Array.isArray(res.data) ? res.data : res.data?.users || [];
// //         setAllUsers(usersArray);
// //       })
// //       .catch(() => onError('Failed to load users.'))
// //       .finally(() => setLoadingUsers(false));
// //   }, [open, onError]);


// //   // Range preview
// //   useEffect(() => {
// //     if (!startRefId || !endRefId || !Array.isArray(rows) || rows.length === 0) {
// //       setRangePreview([]);
// //       return;
// //     }
// //     const sorted = [...rows].sort((a, b) => a.reference_id.localeCompare(b.reference_id));
// //     setRangePreview(sorted.filter(r => r.reference_id >= startRefId && r.reference_id <= endRefId));
// //   }, [startRefId, endRefId, rows]);


// //   // Filter users for regular search (Case Worker)
// //   useEffect(() => {
// //     if (!searchEmail.trim()) {
// //       setFilteredUsers([]);
// //       return;
// //     }
// //     const q = searchEmail.toLowerCase();
// //     setFilteredUsers(
// //       (Array.isArray(allUsers) ? allUsers : []).filter(
// //         u => u.email?.toLowerCase().includes(q) || u.name?.toLowerCase().includes(q)
// //       ).slice(0, 8)
// //     );
// //   }, [searchEmail, allUsers]);


// //   // Filter users for SHR search
// //   useEffect(() => {
// //     if (!shrSearch.trim()) {
// //       setShrFilteredUsers([]);
// //       return;
// //     }
// //     const q = shrSearch.toLowerCase();
// //     setShrFilteredUsers(
// //       (Array.isArray(allUsers) ? allUsers : []).filter(
// //         u => u.email?.toLowerCase().includes(q) || u.name?.toLowerCase().includes(q)
// //       ).slice(0, 8)
// //     );
// //   }, [shrSearch, allUsers]);


// //   // Filter users for Forensic Auditor search
// //   useEffect(() => {
// //     if (!forensicSearch.trim()) {
// //       setFilteredForensicUsers([]);
// //       return;
// //     }
// //     const q = forensicSearch.toLowerCase();
// //     setFilteredForensicUsers(
// //       (Array.isArray(allUsers) ? allUsers : []).filter(
// //         u => u.email?.toLowerCase().includes(q) || u.name?.toLowerCase().includes(q)
// //       ).slice(0, 8)
// //     );
// //   }, [forensicSearch, allUsers]);


// //   const handleClose = useCallback(() => {
// //     setStartRefId('');
// //     setEndRefId('');
// //     setRangePreview([]);
// //     setSearchEmail('');
// //     setFilteredUsers([]);
// //     setPickedUsers([]);
// //     setShrName('');
// //     setShrSearch('');
// //     setShrFilteredUsers([]);
// //     setPickedShr(null);
// //     setForensicSearch('');
// //     setFilteredForensicUsers([]);
// //     setPickedForensic([]);
// //     setMode('add');
// //     onClose();
// //   }, [onClose]);


// //   const toggleUser = (user) => {
// //     setPickedUsers(prev =>
// //       prev.some(u => u.id === user.id)
// //         ? prev.filter(u => u.id !== user.id)
// //         : [...prev, user]
// //     );
// //   };


// //   const toggleShr = (user) => {
// //     if (pickedShr?.id === user.id) {
// //       setPickedShr(null);
// //       setShrName('');
// //     } else {
// //       setPickedShr(user);
// //       setShrName(user.name || '');
// //     }
// //   };


// //   const toggleForensic = (user) => {
// //     setPickedForensic(prev =>
// //       prev.some(u => u.id === user.id)
// //         ? prev.filter(u => u.id !== user.id)
// //         : [...prev, user]
// //     );
// //   };


// //   const handleSubmit = async () => {
// //     if (!Array.isArray(rangePreview) || rangePreview.length === 0) {
// //       onError('No records match the entered range.');
// //       return;
// //     }
// //     if (!Array.isArray(pickedUsers) || pickedUsers.length === 0) {
// //       onError('Please select at least one Case Worker.');
// //       return;
// //     }
// //     if (mode === 'add' && !shrName.trim()) {
// //       onError('SHR Name is required.');
// //       return;
// //     }
// //     // Mandatory in BOTH add and remove modes
// //     if (!Array.isArray(pickedForensic) || pickedForensic.length === 0) {
// //       onError('Please select at least one Forensic Auditor.');
// //       return;
// //     }

// //     const payload = {
// //       excess_ids: rangePreview.map(r => r.id),
// //       user_ids: pickedUsers.map(u => u.id),
// //       forensic_auditor_ids: pickedForensic.map(u => u.id), // always sent, both modes
// //       ...(mode === 'add' && shrName.trim() ? { shr_name: shrName.trim() } : {}),
// //     };

// //     try {
// //       setSubmitting(true);
// //       if (mode === 'add') {
// //         const res = await api.post('/excess_payment_mgmt/excess/bulk-permission/', payload);
// //         onSuccess(`Case Worker access granted. Created: ${res.data.created_count}, Skipped: ${res.data.skipped_count}.`);
// //       } else {
// //         const res = await api.delete('/excess_payment_mgmt/excess/bulk-permission/', { data: payload });
// //         onSuccess(`Case Worker access removed. Deleted: ${res.data.deleted_count}.`);
// //       }
// //       handleClose();
// //     } catch (err) {
// //       onError(err?.response?.data?.error || 'Failed to update permissions.');
// //     } finally {
// //       setSubmitting(false);
// //     }
// //   };


// //   const isAdd = mode === 'add';


// //   return (
// //     <Dialog open={open} onClose={!submitting ? handleClose : undefined} maxWidth="sm" fullWidth>
// //       <DialogTitle sx={{ pb: 1 }}>
// //         <Box display="flex" justifyContent="space-between" alignItems="center">
// //           <Typography variant="h6" fontWeight="bold">Bulk Permission Management</Typography>
// //           <IconButton size="small" onClick={handleClose} disabled={submitting}>
// //             <CloseIcon fontSize="small" />
// //           </IconButton>
// //         </Box>
// //       </DialogTitle>
// //       <Divider />
// //       <DialogContent sx={{ pt: 2 }}>
// //         <Box display="flex" flexDirection="column" gap={2.5}>
// //           {/* Mode Toggle */}
// //           <Box display="flex" gap={1}>
// //             <Button
// //               variant={isAdd ? 'contained' : 'outlined'} color="primary"
// //               startIcon={<PersonAddIcon />} onClick={() => setMode('add')}
// //               disabled={submitting} size="small" sx={{ flex: 1 }}
// //             >Add Permission</Button>
// //             <Button
// //               variant={!isAdd ? 'contained' : 'outlined'} color="error"
// //               startIcon={<PersonRemoveIcon />} onClick={() => setMode('remove')}
// //               disabled={submitting} size="small" sx={{ flex: 1 }}
// //             >Remove Permission</Button>
// //           </Box>


// //           {/* Reference ID Range */}
// //           <Box>
// //             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// //               Reference ID Range
// //             </Typography>
// //             <Box display="flex" gap={2}>
// //               <TextField
// //                 fullWidth size="small" label="From Reference ID"
// //                 value={startRefId} onChange={e => setStartRefId(e.target.value)}
// //                 disabled={submitting}
// //               />
// //               <TextField
// //                 fullWidth size="small" label="To Reference ID"
// //                 value={endRefId} onChange={e => setEndRefId(e.target.value)}
// //                 disabled={submitting}
// //               />
// //             </Box>


// //             {startRefId && endRefId && (
// //               <Box mt={1}>
// //                 {(Array.isArray(rangePreview) && rangePreview.length > 0) ? (
// //                   <Alert severity={isAdd ? 'info' : 'warning'} sx={{ py: 0.5 }}>
// //                     <strong>{rangePreview.length} record(s)</strong> matched —{' '}
// //                     {rangePreview.slice(0, 3).map(r => r.reference_id).join(', ')}
// //                     {rangePreview.length > 3 && ` ... +${rangePreview.length - 3} more`}
// //                   </Alert>
// //                 ) : (
// //                   <Alert severity="error" sx={{ py: 0.5 }}>No records match this range.</Alert>
// //                 )}
// //               </Box>
// //             )}
// //           </Box>


// //           {/* SHR Name Search — Add mode only */}
// //           {isAdd && (
// //             <Box>
// //               <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// //                 Authorized SHR Name <Typography component="span" color="error">*</Typography>
// //               </Typography>
// //               <TextField
// //                 fullWidth size="small"
// //                 placeholder="Type email or name to search..."
// //                 value={shrSearch}
// //                 onChange={e => setShrSearch(e.target.value)}
// //                 disabled={submitting || loadingUsers}
// //                 required
// //                 InputProps={{
// //                   startAdornment: loadingUsers ? <CircularProgress size={16} sx={{ mr: 1 }} /> : <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.disabled' }} />,
// //                   endAdornment: shrSearch && (
// //                     <IconButton size="small" onClick={() => { setShrSearch(''); setPickedShr(null); setShrName(''); }}>
// //                       <CloseIcon fontSize="small" />
// //                     </IconButton>
// //                   ),
// //                 }}
// //               />


// //               {(Array.isArray(shrFilteredUsers) && shrFilteredUsers.length > 0) && (
// //                 <Box sx={{ mt: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, maxHeight: 180, overflow: 'auto' }}>
// //                   {shrFilteredUsers.map((user, idx) => {
// //                     const isPicked = pickedShr?.id === user.id;
// //                     return (
// //                       <Box
// //                         key={user.id}
// //                         onClick={() => toggleShr(user)}
// //                         sx={{
// //                           display: 'flex', alignItems: 'center', gap: 1.5,
// //                           px: 2, py: 1, cursor: 'pointer',
// //                           bgcolor: isPicked ? 'primary.50' : 'transparent',
// //                           borderBottom: idx < shrFilteredUsers.length - 1 ? '1px solid' : 'none',
// //                           borderColor: 'divider',
// //                           '&:hover': { bgcolor: isPicked ? 'primary.100' : 'action.hover' },
// //                           transition: 'background 0.15s',
// //                         }}
// //                       >
// //                         <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: isPicked ? 'primary.main' : 'grey.400' }}>
// //                           {user.name?.[0]?.toUpperCase() || '?'}
// //                         </Avatar>
// //                         <Box flex={1} minWidth={0}>
// //                           <Typography variant="body2" fontWeight={isPicked ? 600 : 400} noWrap>{user.name}</Typography>
// //                           <Typography variant="caption" color="text.secondary" noWrap>{user.email}</Typography>
// //                         </Box>
// //                         {isPicked && <CheckCircleIcon fontSize="small" color="primary" />}
// //                       </Box>
// //                     );
// //                   })}
// //                 </Box>
// //               )}


// //               {pickedShr && (
// //                 <Box mt={1}>
// //                   <Chip
// //                     label={pickedShr.name}
// //                     size="small"
// //                     avatar={
// //                       <Avatar sx={{ bgcolor: 'primary.main', fontSize: 11 }}>
// //                         {pickedShr.name?.[0]?.toUpperCase()}
// //                       </Avatar>
// //                     }
// //                     onDelete={() => { setPickedShr(null); setShrSearch(''); setShrName(''); }}
// //                     color="primary"
// //                     variant="outlined"
// //                   />
// //                 </Box>
// //               )}
// //             </Box>
// //           )}


// //           {/* Forensic Auditor Search — mandatory in BOTH Add and Remove modes */}
// //           <Box>
// //             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// //               Forensic Auditor(s) <Typography component="span" color="error">*</Typography>
// //             </Typography>
// //             <TextField
// //               fullWidth size="small"
// //               placeholder="Type email or name to search..."
// //               value={forensicSearch}
// //               onChange={e => setForensicSearch(e.target.value)}
// //               disabled={submitting || loadingUsers}
// //               required
// //               InputProps={{
// //                 startAdornment: loadingUsers ? <CircularProgress size={16} sx={{ mr: 1 }} /> : <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.disabled' }} />,
// //                 endAdornment: forensicSearch && (
// //                   <IconButton size="small" onClick={() => setForensicSearch('')}>
// //                     <CloseIcon fontSize="small" />
// //                   </IconButton>
// //                 ),
// //               }}
// //             />


// //             {(Array.isArray(filteredForensicUsers) && filteredForensicUsers.length > 0) && (
// //               <Box sx={{ mt: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, maxHeight: 180, overflow: 'auto' }}>
// //                 {filteredForensicUsers.map((user, idx) => {
// //                   const isPicked = pickedForensic.some(u => u.id === user.id);
// //                   return (
// //                     <Box
// //                       key={user.id}
// //                       onClick={() => toggleForensic(user)}
// //                       sx={{
// //                         display: 'flex', alignItems: 'center', gap: 1.5,
// //                         px: 2, py: 1, cursor: 'pointer',
// //                         bgcolor: isPicked ? 'primary.50' : 'transparent',
// //                         borderBottom: idx < filteredForensicUsers.length - 1 ? '1px solid' : 'none',
// //                         borderColor: 'divider',
// //                         '&:hover': { bgcolor: isPicked ? 'primary.100' : 'action.hover' },
// //                         transition: 'background 0.15s',
// //                       }}
// //                     >
// //                       <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: isPicked ? 'primary.main' : 'grey.400' }}>
// //                         {user.name?.[0]?.toUpperCase() || '?'}
// //                       </Avatar>
// //                       <Box flex={1} minWidth={0}>
// //                         <Typography variant="body2" fontWeight={isPicked ? 600 : 400} noWrap>{user.name}</Typography>
// //                         <Typography variant="caption" color="text.secondary" noWrap>{user.email}</Typography>
// //                       </Box>
// //                       {isPicked && <CheckCircleIcon fontSize="small" color="primary" />}
// //                     </Box>
// //                   );
// //                 })}
// //               </Box>
// //             )}


// //             {(Array.isArray(pickedForensic) && pickedForensic.length > 0) && (
// //               <Box mt={1} display="flex" flexWrap="wrap" gap={0.75}>
// //                 {pickedForensic.map(user => (
// //                   <Chip
// //                     key={user.id}
// //                     label={user.email}
// //                     size="small"
// //                     avatar={
// //                       <Avatar sx={{ bgcolor: 'primary.main', fontSize: 11 }}>
// //                         {user.name?.[0]?.toUpperCase()}
// //                       </Avatar>
// //                     }
// //                     onDelete={() => setPickedForensic(prev => prev.filter(u => u.id !== user.id))}
// //                     color="primary"
// //                     variant="outlined"
// //                   />
// //                 ))}
// //               </Box>
// //             )}
// //           </Box>


// //           {/* Case Worker Search — RENAMED from "Search & Select Users by Email" */}
// //           <Box>
// //             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// //               Search &amp; Select Case Worker(s) by Email <Typography component="span" color="error">*</Typography>
// //             </Typography>
// //             <TextField
// //               fullWidth size="small"
// //               placeholder="Type email or name to search..."
// //               value={searchEmail}
// //               onChange={e => setSearchEmail(e.target.value)}
// //               disabled={submitting || loadingUsers}
// //               InputProps={{
// //                 startAdornment: loadingUsers ? <CircularProgress size={16} sx={{ mr: 1 }} /> : <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.disabled' }} />,
// //                 endAdornment: searchEmail && (
// //                   <IconButton size="small" onClick={() => setSearchEmail('')}>
// //                     <CloseIcon fontSize="small" />
// //                   </IconButton>
// //                 ),
// //               }}
// //             />


// //             {(Array.isArray(filteredUsers) && filteredUsers.length > 0) && (
// //               <Box sx={{ mt: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, maxHeight: 180, overflow: 'auto' }}>
// //                 {filteredUsers.map((user, idx) => {
// //                   const isPicked = pickedUsers.some(u => u.id === user.id);
// //                   return (
// //                     <Box
// //                       key={user.id}
// //                       onClick={() => toggleUser(user)}
// //                       sx={{
// //                         display: 'flex', alignItems: 'center', gap: 1.5,
// //                         px: 2, py: 1, cursor: 'pointer',
// //                         bgcolor: isPicked ? 'primary.50' : 'transparent',
// //                         borderBottom: idx < filteredUsers.length - 1 ? '1px solid' : 'none',
// //                         borderColor: 'divider',
// //                         '&:hover': { bgcolor: isPicked ? 'primary.100' : 'action.hover' },
// //                         transition: 'background 0.15s',
// //                       }}
// //                     >
// //                       <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: isPicked ? 'primary.main' : 'grey.400' }}>
// //                         {user.name?.[0]?.toUpperCase() || '?'}
// //                       </Avatar>
// //                       <Box flex={1} minWidth={0}>
// //                         <Typography variant="body2" fontWeight={isPicked ? 600 : 400} noWrap>{user.name}</Typography>
// //                         <Typography variant="caption" color="text.secondary" noWrap>{user.email}</Typography>
// //                       </Box>
// //                       {isPicked && <CheckCircleIcon fontSize="small" color="primary" />}
// //                     </Box>
// //                   );
// //                 })}
// //               </Box>
// //             )}
// //           </Box>


// //           {/* Picked Case Workers Chips */}
// //           {(Array.isArray(pickedUsers) && pickedUsers.length > 0) && (
// //             <Box>
// //               <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// //                 Selected Case Worker(s) ({pickedUsers.length})
// //               </Typography>
// //               <Box display="flex" flexWrap="wrap" gap={0.75}>
// //                 {pickedUsers.map(user => (
// //                   <Chip
// //                     key={user.id}
// //                     label={user.email}
// //                     size="small"
// //                     avatar={
// //                       <Avatar sx={{ bgcolor: isAdd ? 'primary.main' : 'error.main', fontSize: 11 }}>
// //                         {user.name?.[0]?.toUpperCase()}
// //                       </Avatar>
// //                     }
// //                     onDelete={() => setPickedUsers(prev => prev.filter(u => u.id !== user.id))}
// //                     color={isAdd ? 'primary' : 'error'}
// //                     variant="outlined"
// //                   />
// //                 ))}
// //               </Box>
// //             </Box>
// //           )}


// //           {/* Summary */}
// //           {(Array.isArray(rangePreview) && rangePreview.length > 0 && Array.isArray(pickedUsers) && pickedUsers.length > 0) && (
// //             <Alert severity={isAdd ? 'success' : 'warning'} sx={{ py: 0.5 }}>
// //               {isAdd
// //                 ? `Will grant ${pickedUsers.length} Case Worker(s) access to ${rangePreview.length} record(s).`
// //                 : `Will revoke ${pickedUsers.length} Case Worker(s) access from ${rangePreview.length} record(s).`}
// //             </Alert>
// //           )}
// //         </Box>
// //       </DialogContent>


// //       <Divider />


// //       <DialogActions sx={{ px: 3, py: 2 }}>
// //         <Button onClick={handleClose} disabled={submitting}>Cancel</Button>
// //         <Button
// //           onClick={handleSubmit}
// //           variant="contained"
// //           color={isAdd ? 'primary' : 'error'}
// //           disabled={
// //             submitting ||
// //             !Array.isArray(rangePreview) || rangePreview.length === 0 ||
// //             !Array.isArray(pickedUsers) || pickedUsers.length === 0 ||
// //             (isAdd && !shrName.trim()) ||
// //             !Array.isArray(pickedForensic) || pickedForensic.length === 0
// //           }
// //           startIcon={submitting
// //             ? <CircularProgress size={16} color="inherit" />
// //             : isAdd ? <PersonAddIcon /> : <PersonRemoveIcon />}
// //         >
// //           {submitting
// //             ? 'Processing...'
// //             : isAdd
// //               ? `Grant to ${rangePreview.length} Record(s)`
// //               : `Revoke from ${rangePreview.length} Record(s)`}
// //         </Button>
// //       </DialogActions>
// //     </Dialog>
// //   );
// // };


// import React, { useState, useEffect, useCallback } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   TextField,
//   Chip,
//   Avatar,
//   IconButton,
//   CircularProgress,
//   Divider,
//   Alert,
// } from '@mui/material';
// import {
//   Search as SearchIcon,
//   Close as CloseIcon,
//   PersonAdd as PersonAddIcon,
//   PersonRemove as PersonRemoveIcon,
//   CheckCircle as CheckCircleIcon,
// } from '@mui/icons-material';
// import api from '../../../api/axiosInterceptor';


// export const BulkPermissionDialog = ({ open, onClose, rows, onSuccess, onError }) => {
//   const [mode, setMode] = useState('add'); // 'add' | 'remove'
//   const [startRefId, setStartRefId] = useState('');
//   const [endRefId, setEndRefId] = useState('');
//   const [rangePreview, setRangePreview] = useState([]);
//   const [allUsers, setAllUsers] = useState([]);
//   const [searchEmail, setSearchEmail] = useState('');
//   const [filteredUsers, setFilteredUsers] = useState([]);
//   const [pickedUsers, setPickedUsers] = useState([]);
//   const [loadingUsers, setLoadingUsers] = useState(false);
//   const [shrName, setShrName] = useState('');
//   const [shrSearch, setShrSearch] = useState('');
//   const [shrFilteredUsers, setShrFilteredUsers] = useState([]);
//   const [pickedShr, setPickedShr] = useState(null);

//   // Forensic Auditor — multi-select, mandatory in BOTH add and remove modes
//   const [forensicSearch, setForensicSearch] = useState('');
//   const [filteredForensicUsers, setFilteredForensicUsers] = useState([]);
//   const [pickedForensic, setPickedForensic] = useState([]);

//   const [submitting, setSubmitting] = useState(false);


//   // Fetch users on open
//   useEffect(() => {
//     if (!open) return;
//     setLoadingUsers(true);
//     api.get('/auth/role-mgmt/')
//       .then(res => {
//         const usersArray = Array.isArray(res.data) ? res.data : res.data?.users || [];
//         setAllUsers(usersArray);
//       })
//       .catch(() => onError('Failed to load users.'))
//       .finally(() => setLoadingUsers(false));
//   }, [open, onError]);


//   // Range preview
//   useEffect(() => {
//     if (!startRefId || !endRefId || !Array.isArray(rows) || rows.length === 0) {
//       setRangePreview([]);
//       return;
//     }
//     const sorted = [...rows].sort((a, b) => a.reference_id.localeCompare(b.reference_id));
//     setRangePreview(sorted.filter(r => r.reference_id >= startRefId && r.reference_id <= endRefId));
//   }, [startRefId, endRefId, rows]);


//   // Filter users for regular search (Case Worker)
//   useEffect(() => {
//     if (!searchEmail.trim()) {
//       setFilteredUsers([]);
//       return;
//     }
//     const q = searchEmail.toLowerCase();
//     setFilteredUsers(
//       (Array.isArray(allUsers) ? allUsers : []).filter(
//         u => u.email?.toLowerCase().includes(q) || u.name?.toLowerCase().includes(q)
//       ).slice(0, 8)
//     );
//   }, [searchEmail, allUsers]);


//   // Filter users for SHR search
//   useEffect(() => {
//     if (!shrSearch.trim()) {
//       setShrFilteredUsers([]);
//       return;
//     }
//     const q = shrSearch.toLowerCase();
//     setShrFilteredUsers(
//       (Array.isArray(allUsers) ? allUsers : []).filter(
//         u => u.email?.toLowerCase().includes(q) || u.name?.toLowerCase().includes(q)
//       ).slice(0, 8)
//     );
//   }, [shrSearch, allUsers]);


//   // Filter users for Forensic Auditor search
//   useEffect(() => {
//     if (!forensicSearch.trim()) {
//       setFilteredForensicUsers([]);
//       return;
//     }
//     const q = forensicSearch.toLowerCase();
//     setFilteredForensicUsers(
//       (Array.isArray(allUsers) ? allUsers : []).filter(
//         u => u.email?.toLowerCase().includes(q) || u.name?.toLowerCase().includes(q)
//       ).slice(0, 8)
//     );
//   }, [forensicSearch, allUsers]);


//   const handleClose = useCallback(() => {
//     setStartRefId('');
//     setEndRefId('');
//     setRangePreview([]);
//     setSearchEmail('');
//     setFilteredUsers([]);
//     setPickedUsers([]);
//     setShrName('');
//     setShrSearch('');
//     setShrFilteredUsers([]);
//     setPickedShr(null);
//     setForensicSearch('');
//     setFilteredForensicUsers([]);
//     setPickedForensic([]);
//     setMode('add');
//     onClose();
//   }, [onClose]);


//   const toggleUser = (user) => {
//     setPickedUsers(prev =>
//       prev.some(u => u.id === user.id)
//         ? prev.filter(u => u.id !== user.id)
//         : [...prev, user]
//     );
//   };


//   const toggleShr = (user) => {
//     if (pickedShr?.id === user.id) {
//       setPickedShr(null);
//       setShrName('');
//     } else {
//       setPickedShr(user);
//       setShrName(user.name || '');
//     }
//   };


//   const toggleForensic = (user) => {
//     setPickedForensic(prev =>
//       prev.some(u => u.id === user.id)
//         ? prev.filter(u => u.id !== user.id)
//         : [...prev, user]
//     );
//   };


//   const handleSubmit = async () => {
//     if (!Array.isArray(rangePreview) || rangePreview.length === 0) {
//       onError('No records match the entered range.');
//       return;
//     }
//     if (!Array.isArray(pickedUsers) || pickedUsers.length === 0) {
//       onError('Please select at least one Case Worker.');
//       return;
//     }
//     if (mode === 'add' && !pickedShr) {
//       onError('Please select a Shirastedar (SHR) from the search results.');
//       return;
//     }
//     // Mandatory in BOTH add and remove modes
//     if (!Array.isArray(pickedForensic) || pickedForensic.length === 0) {
//       onError('Please select at least one Forensic Auditor.');
//       return;
//     }

//     const payload = {
//       excess_ids: rangePreview.map(r => r.id),
//       user_ids: pickedUsers.map(u => u.id),
//       forensic_auditor_ids: pickedForensic.map(u => u.id), // always sent, both modes
//       // shirastedar_id is the real user id used for permission scoping;
//       // shr_name stays as the display label for existing dashboard filters.
//       ...(mode === 'add' && pickedShr ? { shirastedar_id: pickedShr.id, shr_name: pickedShr.name } : {}),
//     };

//     try {
//       setSubmitting(true);
//       if (mode === 'add') {
//         const res = await api.post('/excess_payment_mgmt/excess/bulk-permission/', payload);
//         onSuccess(`Case Worker access granted. Created: ${res.data.created_count}, Skipped: ${res.data.skipped_count}.`);
//       } else {
//         const res = await api.delete('/excess_payment_mgmt/excess/bulk-permission/', { data: payload });
//         onSuccess(`Case Worker access removed. Deleted: ${res.data.deleted_count}.`);
//       }
//       handleClose();
//     } catch (err) {
//       onError(err?.response?.data?.error || 'Failed to update permissions.');
//     } finally {
//       setSubmitting(false);
//     }
//   };


//   const isAdd = mode === 'add';


//   return (
//     <Dialog open={open} onClose={!submitting ? handleClose : undefined} maxWidth="sm" fullWidth>
//       <DialogTitle sx={{ pb: 1 }}>
//         <Box display="flex" justifyContent="space-between" alignItems="center">
//           <Typography variant="h6" fontWeight="bold">Bulk Permission Management</Typography>
//           <IconButton size="small" onClick={handleClose} disabled={submitting}>
//             <CloseIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       </DialogTitle>
//       <Divider />
//       <DialogContent sx={{ pt: 2 }}>
//         <Box display="flex" flexDirection="column" gap={2.5}>
//           {/* Mode Toggle */}
//           <Box display="flex" gap={1}>
//             <Button
//               variant={isAdd ? 'contained' : 'outlined'} color="primary"
//               startIcon={<PersonAddIcon />} onClick={() => setMode('add')}
//               disabled={submitting} size="small" sx={{ flex: 1 }}
//             >Add Permission</Button>
//             <Button
//               variant={!isAdd ? 'contained' : 'outlined'} color="error"
//               startIcon={<PersonRemoveIcon />} onClick={() => setMode('remove')}
//               disabled={submitting} size="small" sx={{ flex: 1 }}
//             >Remove Permission</Button>
//           </Box>


//           {/* Reference ID Range */}
//           <Box>
//             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
//               Reference ID Range
//             </Typography>
//             <Box display="flex" gap={2}>
//               <TextField
//                 fullWidth size="small" label="From Reference ID"
//                 value={startRefId} onChange={e => setStartRefId(e.target.value)}
//                 disabled={submitting}
//               />
//               <TextField
//                 fullWidth size="small" label="To Reference ID"
//                 value={endRefId} onChange={e => setEndRefId(e.target.value)}
//                 disabled={submitting}
//               />
//             </Box>


//             {startRefId && endRefId && (
//               <Box mt={1}>
//                 {(Array.isArray(rangePreview) && rangePreview.length > 0) ? (
//                   <Alert severity={isAdd ? 'info' : 'warning'} sx={{ py: 0.5 }}>
//                     <strong>{rangePreview.length} record(s)</strong> matched —{' '}
//                     {rangePreview.slice(0, 3).map(r => r.reference_id).join(', ')}
//                     {rangePreview.length > 3 && ` ... +${rangePreview.length - 3} more`}
//                   </Alert>
//                 ) : (
//                   <Alert severity="error" sx={{ py: 0.5 }}>No records match this range.</Alert>
//                 )}
//               </Box>
//             )}
//           </Box>


//           {/* SHR Name Search — Add mode only */}
//           {isAdd && (
//             <Box>
//               <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
//                 Authorized SHR / Shirastedar <Typography component="span" color="error">*</Typography>
//               </Typography>
//               <TextField
//                 fullWidth size="small"
//                 placeholder="Type email or name to search..."
//                 value={shrSearch}
//                 onChange={e => setShrSearch(e.target.value)}
//                 disabled={submitting || loadingUsers}
//                 required
//                 InputProps={{
//                   startAdornment: loadingUsers ? <CircularProgress size={16} sx={{ mr: 1 }} /> : <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.disabled' }} />,
//                   endAdornment: shrSearch && (
//                     <IconButton size="small" onClick={() => { setShrSearch(''); setPickedShr(null); setShrName(''); }}>
//                       <CloseIcon fontSize="small" />
//                     </IconButton>
//                   ),
//                 }}
//               />


//               {(Array.isArray(shrFilteredUsers) && shrFilteredUsers.length > 0) && (
//                 <Box sx={{ mt: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, maxHeight: 180, overflow: 'auto' }}>
//                   {shrFilteredUsers.map((user, idx) => {
//                     const isPicked = pickedShr?.id === user.id;
//                     return (
//                       <Box
//                         key={user.id}
//                         onClick={() => toggleShr(user)}
//                         sx={{
//                           display: 'flex', alignItems: 'center', gap: 1.5,
//                           px: 2, py: 1, cursor: 'pointer',
//                           bgcolor: isPicked ? 'primary.50' : 'transparent',
//                           borderBottom: idx < shrFilteredUsers.length - 1 ? '1px solid' : 'none',
//                           borderColor: 'divider',
//                           '&:hover': { bgcolor: isPicked ? 'primary.100' : 'action.hover' },
//                           transition: 'background 0.15s',
//                         }}
//                       >
//                         <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: isPicked ? 'primary.main' : 'grey.400' }}>
//                           {user.name?.[0]?.toUpperCase() || '?'}
//                         </Avatar>
//                         <Box flex={1} minWidth={0}>
//                           <Typography variant="body2" fontWeight={isPicked ? 600 : 400} noWrap>{user.name}</Typography>
//                           <Typography variant="caption" color="text.secondary" noWrap>{user.email}</Typography>
//                         </Box>
//                         {isPicked && <CheckCircleIcon fontSize="small" color="primary" />}
//                       </Box>
//                     );
//                   })}
//                 </Box>
//               )}


//               {pickedShr && (
//                 <Box mt={1}>
//                   <Chip
//                     label={pickedShr.name}
//                     size="small"
//                     avatar={
//                       <Avatar sx={{ bgcolor: 'primary.main', fontSize: 11 }}>
//                         {pickedShr.name?.[0]?.toUpperCase()}
//                       </Avatar>
//                     }
//                     onDelete={() => { setPickedShr(null); setShrSearch(''); setShrName(''); }}
//                     color="primary"
//                     variant="outlined"
//                   />
//                 </Box>
//               )}
//             </Box>
//           )}


//           {/* Forensic Auditor Search — mandatory in BOTH Add and Remove modes */}
//           <Box>
//             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
//               Forensic Auditor(s) <Typography component="span" color="error">*</Typography>
//             </Typography>
//             <TextField
//               fullWidth size="small"
//               placeholder="Type email or name to search..."
//               value={forensicSearch}
//               onChange={e => setForensicSearch(e.target.value)}
//               disabled={submitting || loadingUsers}
//               required
//               InputProps={{
//                 startAdornment: loadingUsers ? <CircularProgress size={16} sx={{ mr: 1 }} /> : <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.disabled' }} />,
//                 endAdornment: forensicSearch && (
//                   <IconButton size="small" onClick={() => setForensicSearch('')}>
//                     <CloseIcon fontSize="small" />
//                   </IconButton>
//                 ),
//               }}
//             />


//             {(Array.isArray(filteredForensicUsers) && filteredForensicUsers.length > 0) && (
//               <Box sx={{ mt: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, maxHeight: 180, overflow: 'auto' }}>
//                 {filteredForensicUsers.map((user, idx) => {
//                   const isPicked = pickedForensic.some(u => u.id === user.id);
//                   return (
//                     <Box
//                       key={user.id}
//                       onClick={() => toggleForensic(user)}
//                       sx={{
//                         display: 'flex', alignItems: 'center', gap: 1.5,
//                         px: 2, py: 1, cursor: 'pointer',
//                         bgcolor: isPicked ? 'primary.50' : 'transparent',
//                         borderBottom: idx < filteredForensicUsers.length - 1 ? '1px solid' : 'none',
//                         borderColor: 'divider',
//                         '&:hover': { bgcolor: isPicked ? 'primary.100' : 'action.hover' },
//                         transition: 'background 0.15s',
//                       }}
//                     >
//                       <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: isPicked ? 'primary.main' : 'grey.400' }}>
//                         {user.name?.[0]?.toUpperCase() || '?'}
//                       </Avatar>
//                       <Box flex={1} minWidth={0}>
//                         <Typography variant="body2" fontWeight={isPicked ? 600 : 400} noWrap>{user.name}</Typography>
//                         <Typography variant="caption" color="text.secondary" noWrap>{user.email}</Typography>
//                       </Box>
//                       {isPicked && <CheckCircleIcon fontSize="small" color="primary" />}
//                     </Box>
//                   );
//                 })}
//               </Box>
//             )}


//             {(Array.isArray(pickedForensic) && pickedForensic.length > 0) && (
//               <Box mt={1} display="flex" flexWrap="wrap" gap={0.75}>
//                 {pickedForensic.map(user => (
//                   <Chip
//                     key={user.id}
//                     label={user.email}
//                     size="small"
//                     avatar={
//                       <Avatar sx={{ bgcolor: 'primary.main', fontSize: 11 }}>
//                         {user.name?.[0]?.toUpperCase()}
//                       </Avatar>
//                     }
//                     onDelete={() => setPickedForensic(prev => prev.filter(u => u.id !== user.id))}
//                     color="primary"
//                     variant="outlined"
//                   />
//                 ))}
//               </Box>
//             )}
//           </Box>


//           {/* Case Worker Search — RENAMED from "Search & Select Users by Email" */}
//           <Box>
//             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
//               Search &amp; Select Case Worker(s) by Email <Typography component="span" color="error">*</Typography>
//             </Typography>
//             <TextField
//               fullWidth size="small"
//               placeholder="Type email or name to search..."
//               value={searchEmail}
//               onChange={e => setSearchEmail(e.target.value)}
//               disabled={submitting || loadingUsers}
//               InputProps={{
//                 startAdornment: loadingUsers ? <CircularProgress size={16} sx={{ mr: 1 }} /> : <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.disabled' }} />,
//                 endAdornment: searchEmail && (
//                   <IconButton size="small" onClick={() => setSearchEmail('')}>
//                     <CloseIcon fontSize="small" />
//                   </IconButton>
//                 ),
//               }}
//             />


//             {(Array.isArray(filteredUsers) && filteredUsers.length > 0) && (
//               <Box sx={{ mt: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, maxHeight: 180, overflow: 'auto' }}>
//                 {filteredUsers.map((user, idx) => {
//                   const isPicked = pickedUsers.some(u => u.id === user.id);
//                   return (
//                     <Box
//                       key={user.id}
//                       onClick={() => toggleUser(user)}
//                       sx={{
//                         display: 'flex', alignItems: 'center', gap: 1.5,
//                         px: 2, py: 1, cursor: 'pointer',
//                         bgcolor: isPicked ? 'primary.50' : 'transparent',
//                         borderBottom: idx < filteredUsers.length - 1 ? '1px solid' : 'none',
//                         borderColor: 'divider',
//                         '&:hover': { bgcolor: isPicked ? 'primary.100' : 'action.hover' },
//                         transition: 'background 0.15s',
//                       }}
//                     >
//                       <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: isPicked ? 'primary.main' : 'grey.400' }}>
//                         {user.name?.[0]?.toUpperCase() || '?'}
//                       </Avatar>
//                       <Box flex={1} minWidth={0}>
//                         <Typography variant="body2" fontWeight={isPicked ? 600 : 400} noWrap>{user.name}</Typography>
//                         <Typography variant="caption" color="text.secondary" noWrap>{user.email}</Typography>
//                       </Box>
//                       {isPicked && <CheckCircleIcon fontSize="small" color="primary" />}
//                     </Box>
//                   );
//                 })}
//               </Box>
//             )}
//           </Box>


//           {/* Picked Case Workers Chips */}
//           {(Array.isArray(pickedUsers) && pickedUsers.length > 0) && (
//             <Box>
//               <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
//                 Selected Case Worker(s) ({pickedUsers.length})
//               </Typography>
//               <Box display="flex" flexWrap="wrap" gap={0.75}>
//                 {pickedUsers.map(user => (
//                   <Chip
//                     key={user.id}
//                     label={user.email}
//                     size="small"
//                     avatar={
//                       <Avatar sx={{ bgcolor: isAdd ? 'primary.main' : 'error.main', fontSize: 11 }}>
//                         {user.name?.[0]?.toUpperCase()}
//                       </Avatar>
//                     }
//                     onDelete={() => setPickedUsers(prev => prev.filter(u => u.id !== user.id))}
//                     color={isAdd ? 'primary' : 'error'}
//                     variant="outlined"
//                   />
//                 ))}
//               </Box>
//             </Box>
//           )}


//           {/* Summary */}
//           {(Array.isArray(rangePreview) && rangePreview.length > 0 && Array.isArray(pickedUsers) && pickedUsers.length > 0) && (
//             <Alert severity={isAdd ? 'success' : 'warning'} sx={{ py: 0.5 }}>
//               {isAdd
//                 ? `Will grant ${pickedUsers.length} Case Worker(s) access to ${rangePreview.length} record(s).`
//                 : `Will revoke ${pickedUsers.length} Case Worker(s) access from ${rangePreview.length} record(s).`}
//             </Alert>
//           )}
//         </Box>
//       </DialogContent>


//       <Divider />


//       <DialogActions sx={{ px: 3, py: 2 }}>
//         <Button onClick={handleClose} disabled={submitting}>Cancel</Button>
//         <Button
//           onClick={handleSubmit}
//           variant="contained"
//           color={isAdd ? 'primary' : 'error'}
//           disabled={
//             submitting ||
//             !Array.isArray(rangePreview) || rangePreview.length === 0 ||
//             !Array.isArray(pickedUsers) || pickedUsers.length === 0 ||
//             (isAdd && !pickedShr) ||
//             !Array.isArray(pickedForensic) || pickedForensic.length === 0
//           }
//           startIcon={submitting
//             ? <CircularProgress size={16} color="inherit" />
//             : isAdd ? <PersonAddIcon /> : <PersonRemoveIcon />}
//         >
//           {submitting
//             ? 'Processing...'
//             : isAdd
//               ? `Grant to ${rangePreview.length} Record(s)`
//               : `Revoke from ${rangePreview.length} Record(s)`}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

import React, { useState, useEffect, useCallback } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  TextField,
  Chip,
  Avatar,
  IconButton,
  CircularProgress,
  Divider,
  Alert,
} from '@mui/material';
import {
  Search as SearchIcon,
  Close as CloseIcon,
  PersonAdd as PersonAddIcon,
  PersonRemove as PersonRemoveIcon,
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material';
import api from '../../../api/axiosInterceptor';


export const BulkPermissionDialog = ({ open, onClose, rows, onSuccess, onError }) => {
  const [mode, setMode] = useState('add'); // 'add' | 'remove'
  const [startRefId, setStartRefId] = useState('');
  const [endRefId, setEndRefId] = useState('');
  const [rangePreview, setRangePreview] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [searchEmail, setSearchEmail] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [pickedUsers, setPickedUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [shrName, setShrName] = useState('');
  const [shrSearch, setShrSearch] = useState('');
  const [shrFilteredUsers, setShrFilteredUsers] = useState([]);
  const [pickedShr, setPickedShr] = useState(null);

  // Forensic Auditor — multi-select, mandatory in BOTH add and remove modes
  const [forensicSearch, setForensicSearch] = useState('');
  const [filteredForensicUsers, setFilteredForensicUsers] = useState([]);
  const [pickedForensic, setPickedForensic] = useState([]);

  const [submitting, setSubmitting] = useState(false);


  // Fetch users on open
  useEffect(() => {
    if (!open) return;
    setLoadingUsers(true);
    api.get('/auth/role-mgmt/')
      .then(res => {
        const usersArray = Array.isArray(res.data) ? res.data : res.data?.users || [];
        setAllUsers(usersArray);
      })
      .catch(() => onError('Failed to load users.'))
      .finally(() => setLoadingUsers(false));
  }, [open, onError]);


  // Range preview
  useEffect(() => {
    if (!startRefId || !endRefId || !Array.isArray(rows) || rows.length === 0) {
      setRangePreview([]);
      return;
    }
    const sorted = [...rows].sort((a, b) => a.reference_id.localeCompare(b.reference_id));
    setRangePreview(sorted.filter(r => r.reference_id >= startRefId && r.reference_id <= endRefId));
  }, [startRefId, endRefId, rows]);


  // Filter users for regular search (Case Worker)
  useEffect(() => {
    if (!searchEmail.trim()) {
      setFilteredUsers([]);
      return;
    }
    const q = searchEmail.toLowerCase();
    setFilteredUsers(
      (Array.isArray(allUsers) ? allUsers : []).filter(
        u => u.email?.toLowerCase().includes(q) || u.name?.toLowerCase().includes(q)
      ).slice(0, 8)
    );
  }, [searchEmail, allUsers]);


  // Filter users for SHR search
  useEffect(() => {
    if (!shrSearch.trim()) {
      setShrFilteredUsers([]);
      return;
    }
    const q = shrSearch.toLowerCase();
    setShrFilteredUsers(
      (Array.isArray(allUsers) ? allUsers : []).filter(
        u => u.email?.toLowerCase().includes(q) || u.name?.toLowerCase().includes(q)
      ).slice(0, 8)
    );
  }, [shrSearch, allUsers]);


  // Filter users for Forensic Auditor search
  useEffect(() => {
    if (!forensicSearch.trim()) {
      setFilteredForensicUsers([]);
      return;
    }
    const q = forensicSearch.toLowerCase();
    setFilteredForensicUsers(
      (Array.isArray(allUsers) ? allUsers : []).filter(
        u => u.email?.toLowerCase().includes(q) || u.name?.toLowerCase().includes(q)
      ).slice(0, 8)
    );
  }, [forensicSearch, allUsers]);


  const handleClose = useCallback(() => {
    setStartRefId('');
    setEndRefId('');
    setRangePreview([]);
    setSearchEmail('');
    setFilteredUsers([]);
    setPickedUsers([]);
    setShrName('');
    setShrSearch('');
    setShrFilteredUsers([]);
    setPickedShr(null);
    setForensicSearch('');
    setFilteredForensicUsers([]);
    setPickedForensic([]);
    setMode('add');
    onClose();
  }, [onClose]);


  const toggleUser = (user) => {
    setPickedUsers(prev =>
      prev.some(u => u.id === user.id)
        ? prev.filter(u => u.id !== user.id)
        : [...prev, user]
    );
  };


  const toggleShr = (user) => {
    if (pickedShr?.id === user.id) {
      setPickedShr(null);
      setShrName('');
    } else {
      setPickedShr(user);
      setShrName(user.name || '');
    }
  };


  const toggleForensic = (user) => {
    setPickedForensic(prev =>
      prev.some(u => u.id === user.id)
        ? prev.filter(u => u.id !== user.id)
        : [...prev, user]
    );
  };


  const handleSubmit = async () => {
    if (!Array.isArray(rangePreview) || rangePreview.length === 0) {
      onError('No records match the entered range.');
      return;
    }
    if (!Array.isArray(pickedUsers) || pickedUsers.length === 0) {
      onError('Please select at least one Case Worker.');
      return;
    }
    if (mode === 'add' && !pickedShr) {
      onError('Please select a Shirastedar (SHR) from the search results.');
      return;
    }
    // Mandatory in BOTH add and remove modes
    if (!Array.isArray(pickedForensic) || pickedForensic.length === 0) {
      onError('Please select at least one Forensic Auditor.');
      return;
    }

    const payload = {
      excess_ids: rangePreview.map(r => r.id),
      user_ids: pickedUsers.map(u => u.id),
      forensic_auditor_ids: pickedForensic.map(u => u.id), // always sent, both modes
      // shirastedar_id is the real user id used for permission scoping;
      // shr_name stays as the display label for existing dashboard filters.
      ...(mode === 'add' && pickedShr ? { shirastedar_id: pickedShr.id, shr_name: pickedShr.name } : {}),
    };

    try {
      setSubmitting(true);
      if (mode === 'add') {
        const res = await api.post('/excess_payment_mgmt/excess/bulk-permission/', payload);
        onSuccess(`Case Worker access granted. Created: ${res.data.created_count}, Skipped: ${res.data.skipped_count}.`);
      } else {
        const res = await api.delete('/excess_payment_mgmt/excess/bulk-permission/', { data: payload });
        onSuccess(`Case Worker access removed. Deleted: ${res.data.deleted_count}.`);
      }
      handleClose();
    } catch (err) {
      onError(err?.response?.data?.error || 'Failed to update permissions.');
    } finally {
      setSubmitting(false);
    }
  };


  const isAdd = mode === 'add';


  return (
    <Dialog open={open} onClose={!submitting ? handleClose : undefined} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight="bold">Bulk Permission Management</Typography>
          <IconButton size="small" onClick={handleClose} disabled={submitting}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 2 }}>
        <Box display="flex" flexDirection="column" gap={2.5}>
          {/* Mode Toggle */}
          <Box display="flex" gap={1}>
            <Button
              variant={isAdd ? 'contained' : 'outlined'} color="primary"
              startIcon={<PersonAddIcon />} onClick={() => setMode('add')}
              disabled={submitting} size="small" sx={{ flex: 1 }}
            >Add Permission</Button>
            <Button
              variant={!isAdd ? 'contained' : 'outlined'} color="error"
              startIcon={<PersonRemoveIcon />} onClick={() => setMode('remove')}
              disabled={submitting} size="small" sx={{ flex: 1 }}
            >Remove Permission</Button>
          </Box>


          {/* Reference ID Range */}
          <Box>
            <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
              Reference ID Range
            </Typography>
            <Box display="flex" gap={2}>
              <TextField
                fullWidth size="small" label="From Reference ID"
                value={startRefId} onChange={e => setStartRefId(e.target.value)}
                disabled={submitting}
              />
              <TextField
                fullWidth size="small" label="To Reference ID"
                value={endRefId} onChange={e => setEndRefId(e.target.value)}
                disabled={submitting}
              />
            </Box>


            {startRefId && endRefId && (
              <Box mt={1}>
                {(Array.isArray(rangePreview) && rangePreview.length > 0) ? (
                  <Alert severity={isAdd ? 'info' : 'warning'} sx={{ py: 0.5 }}>
                    <strong>{rangePreview.length} record(s)</strong> matched —{' '}
                    {rangePreview.slice(0, 3).map(r => r.reference_id).join(', ')}
                    {rangePreview.length > 3 && ` ... +${rangePreview.length - 3} more`}
                  </Alert>
                ) : (
                  <Alert severity="error" sx={{ py: 0.5 }}>No records match this range.</Alert>
                )}
              </Box>
            )}
          </Box>


          {/* SHR Name Search — Add mode only */}
          {isAdd && (
            <Box>
              <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                Authorized SHR / Shirastedar <Typography component="span" color="error">*</Typography>
              </Typography>
              <TextField
                fullWidth size="small"
                placeholder="Type email or name to search..."
                value={shrSearch}
                onChange={e => setShrSearch(e.target.value)}
                disabled={submitting || loadingUsers}
                required
                InputProps={{
                  startAdornment: loadingUsers ? <CircularProgress size={16} sx={{ mr: 1 }} /> : <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.disabled' }} />,
                  endAdornment: shrSearch && (
                    <IconButton size="small" onClick={() => { setShrSearch(''); setPickedShr(null); setShrName(''); }}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  ),
                }}
              />


              {(Array.isArray(shrFilteredUsers) && shrFilteredUsers.length > 0) && (
                <Box sx={{ mt: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, maxHeight: 180, overflow: 'auto' }}>
                  {shrFilteredUsers.map((user, idx) => {
                    const isPicked = pickedShr?.id === user.id;
                    return (
                      <Box
                        key={user.id}
                        onClick={() => toggleShr(user)}
                        sx={{
                          display: 'flex', alignItems: 'center', gap: 1.5,
                          px: 2, py: 1, cursor: 'pointer',
                          bgcolor: isPicked ? 'primary.50' : 'transparent',
                          borderBottom: idx < shrFilteredUsers.length - 1 ? '1px solid' : 'none',
                          borderColor: 'divider',
                          '&:hover': { bgcolor: isPicked ? 'primary.100' : 'action.hover' },
                          transition: 'background 0.15s',
                        }}
                      >
                        <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: isPicked ? 'primary.main' : 'grey.400' }}>
                          {user.name?.[0]?.toUpperCase() || '?'}
                        </Avatar>
                        <Box flex={1} minWidth={0}>
                          <Typography variant="body2" fontWeight={isPicked ? 600 : 400} noWrap>{user.name}</Typography>
                          <Typography variant="caption" color="text.secondary" noWrap>{user.email}</Typography>
                        </Box>
                        {isPicked && <CheckCircleIcon fontSize="small" color="primary" />}
                      </Box>
                    );
                  })}
                </Box>
              )}


              {pickedShr && (
                <Box mt={1}>
                  <Chip
                    label={pickedShr.name}
                    size="small"
                    avatar={
                      <Avatar sx={{ bgcolor: 'primary.main', fontSize: 11 }}>
                        {pickedShr.name?.[0]?.toUpperCase()}
                      </Avatar>
                    }
                    onDelete={() => { setPickedShr(null); setShrSearch(''); setShrName(''); }}
                    color="primary"
                    variant="outlined"
                  />
                </Box>
              )}
            </Box>
          )}


          {/* Forensic Auditor Search — mandatory in BOTH Add and Remove modes */}
          <Box>
            <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
              Forensic Auditor(s) <Typography component="span" color="error">*</Typography>
            </Typography>
            <TextField
              fullWidth size="small"
              placeholder="Type email or name to search..."
              value={forensicSearch}
              onChange={e => setForensicSearch(e.target.value)}
              disabled={submitting || loadingUsers}
              required
              InputProps={{
                startAdornment: loadingUsers ? <CircularProgress size={16} sx={{ mr: 1 }} /> : <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.disabled' }} />,
                endAdornment: forensicSearch && (
                  <IconButton size="small" onClick={() => setForensicSearch('')}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            />


            {(Array.isArray(filteredForensicUsers) && filteredForensicUsers.length > 0) && (
              <Box sx={{ mt: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, maxHeight: 180, overflow: 'auto' }}>
                {filteredForensicUsers.map((user, idx) => {
                  const isPicked = pickedForensic.some(u => u.id === user.id);
                  return (
                    <Box
                      key={user.id}
                      onClick={() => toggleForensic(user)}
                      sx={{
                        display: 'flex', alignItems: 'center', gap: 1.5,
                        px: 2, py: 1, cursor: 'pointer',
                        bgcolor: isPicked ? 'primary.50' : 'transparent',
                        borderBottom: idx < filteredForensicUsers.length - 1 ? '1px solid' : 'none',
                        borderColor: 'divider',
                        '&:hover': { bgcolor: isPicked ? 'primary.100' : 'action.hover' },
                        transition: 'background 0.15s',
                      }}
                    >
                      <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: isPicked ? 'primary.main' : 'grey.400' }}>
                        {user.name?.[0]?.toUpperCase() || '?'}
                      </Avatar>
                      <Box flex={1} minWidth={0}>
                        <Typography variant="body2" fontWeight={isPicked ? 600 : 400} noWrap>{user.name}</Typography>
                        <Typography variant="caption" color="text.secondary" noWrap>{user.email}</Typography>
                      </Box>
                      {isPicked && <CheckCircleIcon fontSize="small" color="primary" />}
                    </Box>
                  );
                })}
              </Box>
            )}


            {(Array.isArray(pickedForensic) && pickedForensic.length > 0) && (
              <Box mt={1} display="flex" flexWrap="wrap" gap={0.75}>
                {pickedForensic.map(user => (
                  <Chip
                    key={user.id}
                    label={user.email}
                    size="small"
                    avatar={
                      <Avatar sx={{ bgcolor: 'primary.main', fontSize: 11 }}>
                        {user.name?.[0]?.toUpperCase()}
                      </Avatar>
                    }
                    onDelete={() => setPickedForensic(prev => prev.filter(u => u.id !== user.id))}
                    color="primary"
                    variant="outlined"
                  />
                ))}
              </Box>
            )}
          </Box>


          {/* Case Worker Search — RENAMED from "Search & Select Users by Email" */}
          <Box>
            <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
              Search &amp; Select Case Worker(s) by Email <Typography component="span" color="error">*</Typography>
            </Typography>
            <TextField
              fullWidth size="small"
              placeholder="Type email or name to search..."
              value={searchEmail}
              onChange={e => setSearchEmail(e.target.value)}
              disabled={submitting || loadingUsers}
              InputProps={{
                startAdornment: loadingUsers ? <CircularProgress size={16} sx={{ mr: 1 }} /> : <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.disabled' }} />,
                endAdornment: searchEmail && (
                  <IconButton size="small" onClick={() => setSearchEmail('')}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            />


            {(Array.isArray(filteredUsers) && filteredUsers.length > 0) && (
              <Box sx={{ mt: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, maxHeight: 180, overflow: 'auto' }}>
                {filteredUsers.map((user, idx) => {
                  const isPicked = pickedUsers.some(u => u.id === user.id);
                  return (
                    <Box
                      key={user.id}
                      onClick={() => toggleUser(user)}
                      sx={{
                        display: 'flex', alignItems: 'center', gap: 1.5,
                        px: 2, py: 1, cursor: 'pointer',
                        bgcolor: isPicked ? 'primary.50' : 'transparent',
                        borderBottom: idx < filteredUsers.length - 1 ? '1px solid' : 'none',
                        borderColor: 'divider',
                        '&:hover': { bgcolor: isPicked ? 'primary.100' : 'action.hover' },
                        transition: 'background 0.15s',
                      }}
                    >
                      <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: isPicked ? 'primary.main' : 'grey.400' }}>
                        {user.name?.[0]?.toUpperCase() || '?'}
                      </Avatar>
                      <Box flex={1} minWidth={0}>
                        <Typography variant="body2" fontWeight={isPicked ? 600 : 400} noWrap>{user.name}</Typography>
                        <Typography variant="caption" color="text.secondary" noWrap>{user.email}</Typography>
                      </Box>
                      {isPicked && <CheckCircleIcon fontSize="small" color="primary" />}
                    </Box>
                  );
                })}
              </Box>
            )}
          </Box>


          {/* Picked Case Workers Chips */}
          {(Array.isArray(pickedUsers) && pickedUsers.length > 0) && (
            <Box>
              <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                Selected Case Worker(s) ({pickedUsers.length})
              </Typography>
              <Box display="flex" flexWrap="wrap" gap={0.75}>
                {pickedUsers.map(user => (
                  <Chip
                    key={user.id}
                    label={user.email}
                    size="small"
                    avatar={
                      <Avatar sx={{ bgcolor: isAdd ? 'primary.main' : 'error.main', fontSize: 11 }}>
                        {user.name?.[0]?.toUpperCase()}
                      </Avatar>
                    }
                    onDelete={() => setPickedUsers(prev => prev.filter(u => u.id !== user.id))}
                    color={isAdd ? 'primary' : 'error'}
                    variant="outlined"
                  />
                ))}
              </Box>
            </Box>
          )}


          {/* Summary */}
          {(Array.isArray(rangePreview) && rangePreview.length > 0 && Array.isArray(pickedUsers) && pickedUsers.length > 0) && (
            <Alert severity={isAdd ? 'success' : 'warning'} sx={{ py: 0.5 }}>
              {isAdd
                ? `Will grant ${pickedUsers.length} Case Worker(s) access to ${rangePreview.length} record(s).`
                : `Will revoke ${pickedUsers.length} Case Worker(s) access from ${rangePreview.length} record(s).`}
            </Alert>
          )}
        </Box>
      </DialogContent>


      <Divider />


      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={handleClose} disabled={submitting}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color={isAdd ? 'primary' : 'error'}
          disabled={
            submitting ||
            !Array.isArray(rangePreview) || rangePreview.length === 0 ||
            !Array.isArray(pickedUsers) || pickedUsers.length === 0 ||
            (isAdd && !pickedShr) ||
            !Array.isArray(pickedForensic) || pickedForensic.length === 0
          }
          startIcon={submitting
            ? <CircularProgress size={16} color="inherit" />
            : isAdd ? <PersonAddIcon /> : <PersonRemoveIcon />}
        >
          {submitting
            ? 'Processing...'
            : isAdd
              ? `Grant to ${rangePreview.length} Record(s)`
              : `Revoke from ${rangePreview.length} Record(s)`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};